/* eslint eqeqeq: "off" */
import React, { useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import Context from "./Context";
import moment from "moment";
// imagens.
import salvar from '../images/salvar.png';
import novo from '../images/novo.png';
import deletar from '../images/deletar.png';
import editar from '../images/editar.png';
import back from '../images/back.png';
import lupa from '../images/lupa.png'
import impressora from '../images/imprimir.png'
// import salvar from "../images/salvar.svg";
import "moment/locale/pt-br";
import modal from "../functions/modal";
import { useHistory } from "react-router-dom";
import Filter from "../components/Filter";
import { PieChart, Pie, Tooltip, ComposedChart, Line, Area, Legend, XAxis, YAxis, CartesianGrid } from 'recharts';
import pdfMake from "pdfmake/build/pdfmake";
import selector from '../functions/selector';
import masknumber from '../functions/masknumber';
import toast from '../functions/toast';
import checkinput from "../functions/checkinput";

// JSON to XML.
const parser = require('json-xml-parse');

function Faturamento() {

  // context.
  const {
    pagina, setpagina,
    html,
    operadoras, setoperadoras,
    setselectedoperadora, selectedoperadora,
    procedimentos, setprocedimentos,
    selectedprocedimento, setselectedprocedimento,
    setdialogo,
    cliente,
    usuarios,
    setobjatendimento,
    settoast,
  } = useContext(Context);

  // history (router).
  let history = useHistory();

  const [localfaturamento, setlocalfaturamento] = useState([]);
  const [statelocalfaturamento, setstatelocalfaturamento] = useState([]);
  const builddonutfaturamentodata = (arrayfaturamento, status) => {
    let total = 0;
    arrayfaturamento.filter(item => item.status_pagamento == status).map(item => {
      total = parseFloat(total) + parseFloat(item.valor_pagamento);
      return null;
    });
    return total.toFixed(2);
  }

  const buildtotalvalorfaturamento = (arrayfaturamento) => {
    let total = 0;
    arrayfaturamento.map(item => {
      total = parseFloat(total) + parseFloat(item.valor_pagamento);
      return null;
    });
    return total.toFixed(2);
  }

  const donutfaturamentodata = () => {
    return (
      [
        { name: 'PAGAMENTOS EM ABERTO', value: parseFloat(dadosdonutaberto), fill: '#f5d142' },
        { name: 'PAGAMENTOS VENCIDOS', value: parseFloat(dadosdonutvencido), fill: '#EC7063' },
        { name: 'PAGAMENTOS RECEBIDOS', value: parseFloat(dadosdonutpago), fill: '#52be80' },
      ]
    )
  }

  const [dadosdonutaberto, setdadosdonutaberto] = useState();
  const [dadosdonutvencido, setdadosdonutvencido] = useState();
  const [dadosdonutpago, setdadosdonutpago] = useState();
  const loadfaturamentosmes = (data) => {
    setprocessando(0);
    axios.get(html + 'list_faturamento_clinicas/' + cliente.id_cliente).then((response) => {
      let x = [];
      let y = [];
      x = response.data.rows;
      setallfaturamento(x);
      localStorage.setItem('storage_allfaturamento', JSON.stringify(x));

      y = x.filter(fat => moment(fat.data_registro, 'DD/MM/YYYY').format('MM-YYYY') == data);
      console.log('FATURAMENTO DE TODOS OS MESES:')
      console.log(y);
      setstatelocalfaturamento(y);
      setlocalfaturamento(y);
      setprocessando(1);
      //setTimeout(() => {
      refreshChart(JSON.parse(localStorage.getItem('fat_atendimentos_mes')), JSON.parse(localStorage.getItem('fat_procedimentos_mes')), y);
      //}, 2000);
    });
  }

  // criar endpoint para pegar todos os registros de faturamento do cliente (não filtrar por mês).
  const refreshChart = (arrayatendimentos, arrayprocedimentos, arrayfaturamentos) => {
    // captando registros de consultas (arrayatendimentos).
    let arrayfaturasconsultas = [];
    let arrayfaturasprocedimentos = [];

    console.log('## REFRESHCHART ##');
    console.log('ATENDIMENTOS DO MÊS:');
    console.log(arrayatendimentos);
    console.log('PROCEDIMENTOS DO MÊS:');
    console.log(arrayprocedimentos);
    console.log('FATURAMENTOS (TODOS OS MESES):');
    console.log(arrayfaturamentos);

    if (arrayatendimentos != null) {
      arrayatendimentos.map(cons => {
        if (arrayfaturamentos.filter(fat => fat.atendimento_id == cons.id_atendimento).length > 0) {
          arrayfaturamentos.filter(fat => fat.atendimento_id == cons.id_atendimento).map(fat => {
            arrayfaturasconsultas.push(fat);
            return null;
          });
        }
        return null;
      });
    }
    if (arrayprocedimentos != null) {
      arrayprocedimentos.map(proc => {
        if (arrayfaturamentos.filter(fat => fat.procedimento_id == proc.id).length > 0) {
          arrayfaturamentos.filter(fat => fat.procedimento_id == proc.id).map(fat => {
            arrayfaturasprocedimentos.push(fat);
            return null;
          });
        }
        return null;
      });
    }
    let faturamento = [];
    console.log('FATURAMENTO DE CONSULTAS DO MÊS:');
    console.log(arrayfaturasconsultas);
    console.log('FATURAMENTO DE PROCEDIMENTOS DO MÊS:');
    console.log(arrayfaturasprocedimentos);

    arrayfaturasconsultas.map(item => faturamento.push(item));
    arrayfaturasprocedimentos.map(item => faturamento.push(item));

    console.log('TOTAL DE FATURAMENTOS DO MÊS:');
    console.log(faturamento);
    buildtotalvalorfaturamento(faturamento);
    setdadosdonutaberto(builddonutfaturamentodata(faturamento, 'ABERTO'));
    setdadosdonutvencido(builddonutfaturamentodata(faturamento, 'VENCIDO'));
    setdadosdonutpago(builddonutfaturamentodata(faturamento, 'PAGO'));
  }

  const refreshfaturamentomes = () => {
    console.log('refreshfaturamentomes');
    let x = [];
    let localarray = [];
    x = statelocalfaturamento;
    let tipoatendimento = localStorage.getItem('tipoatendimento');
    let modopagamento = localStorage.getItem('formapagamento');
    let selectedprocedimento = localStorage.getItem('procedimento_selecionado');
    let usuario = localStorage.getItem('usuario');

    setstatusatendimento('');

    console.log(tipoatendimento);
    console.log(modopagamento);
    console.log(selectedprocedimento);

    let localatendimentos = [];
    let localprocedimentos = [];

    const getfaturamentoprofissional = (arrayatendimentos, arrayprocedimentos, arrayfaturamentos) => {
      let arrayfaturasconsultas = [];
      let arrayfaturasprocedimentos = [];

      if (arrayatendimentos != null) {
        arrayatendimentos.map(cons => {
          if (arrayfaturamentos.filter(fat => fat.atendimento_id == cons.id_atendimento).length > 0) {
            arrayfaturamentos.filter(fat => fat.atendimento_id == cons.id_atendimento).map(fat => {
              arrayfaturasconsultas.push(fat);
              return null;
            });
          }
          return null;
        });
      }
      if (arrayprocedimentos != null) {
        arrayprocedimentos.map(proc => {
          if (arrayfaturamentos.filter(fat => fat.procedimento_id == proc.id).length > 0) {
            arrayfaturamentos.filter(fat => fat.procedimento_id == proc.id).map(fat => {
              arrayfaturasprocedimentos.push(fat);
              return null;
            });
          }
          return null;
        });
      }
      let faturamento = [];
      console.log('FATURAMENTO DE CONSULTAS DO MÊS:');
      console.log(arrayfaturasconsultas);
      console.log('FATURAMENTO DE PROCEDIMENTOS DO MÊS:');
      console.log(arrayfaturasprocedimentos);
      arrayfaturasconsultas.map(item => faturamento.push(item));
      arrayfaturasprocedimentos.map(item => faturamento.push(item));
      setlocalfaturamento(faturamento);
    }

    if (usuario == 'todos') {
      console.log('TODOS OS USUÁRIOS');
      // filtro para todas as consultas (particulares e convênio).
      if (tipoatendimento == 'CONSULTAS' && modopagamento == 'TODAS') {
        setatendimentos_mes(stateatendimentos_mes);
        localatendimentos = stateatendimentos_mes
        setprocedimentos_mes([]);
        setlocalfaturamento(x.filter(fat => fat.atendimento_id != null));
        localarray = x.filter(fat => fat.atendimento_id != null);
        // filtro para consultas de convênio.
      } else if (tipoatendimento == 'CONSULTAS' && modopagamento == 'CONVÊNIO') {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('CONVÊNIO')));
        localatendimentos = stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('CONVÊNIO'));
        setprocedimentos_mes([]);
        setlocalfaturamento(x.filter(fat => fat.atendimento_id != null && fat.forma_pagamento == 'CONVÊNIO'));
        localarray = x.filter(fat => fat.atendimento_id != null && fat.forma_pagamento == 'CONVÊNIO');
        // filtro para consultas particulares.
      } else if (tipoatendimento == 'CONSULTAS' && modopagamento == 'PARTICULAR') {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('PARTICULAR')));
        localatendimentos = stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('PARTICULAR'));
        setprocedimentos_mes([]);
        setlocalfaturamento(x.filter(fat => fat.atendimento_id != null && fat.forma_pagamento != 'CONVÊNIO'));
        localarray = x.filter(fat => fat.atendimento_id != null && fat.forma_pagamento != 'CONVÊNIO');
        // filtro para todos os procedimentos (particulares e convênios).
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento == 0 && modopagamento == 'TODAS') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes);
        localprocedimentos = stateprocedimentos_mes;
        setlocalfaturamento(x.filter(fat => fat.procedimento_id != null));
        localarray = x.filter(fat => fat.procedimento_id != null);
        // filtro para todos procedimentos de convênio.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento == 0 && modopagamento == 'CONVÊNIO') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.convenio == 1));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.convenio == 1);
        setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.forma_pagamento == 'CONVÊNIO'));
        localarray = x.filter(fat => fat.procedimento_id != null && fat.forma_pagamento == 'CONVÊNIO');
        // filtro para todos os procedimentos particulares.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento == 0 && modopagamento == 'PARTICULAR') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.particular == 1));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.particular == 1);
        setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.forma_pagamento != 'CONVÊNIO'));
        localarray = x.filter(fat => fat.procedimento_id != null && fat.forma_pagamento != 'CONVÊNIO');
        // filtro para um determinado procedimento, convênio ou particular.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento != 0 && modopagamento == 'TODAS') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento);
        setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento));
        localarray = x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento);
        // filtro para um determinado procedimento, convênio.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento != 0 && modopagamento == 'CONVÊNIO') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.convenio == 1));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.convenio == 1);
        setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento && fat.forma_pagamento == 'CONVÊNIO'));
        localarray = x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento && fat.forma_pagamento == 'CONVÊNIO');
        // filtro para um determinado procedimento, particular.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento != 0 && modopagamento != 'CONVÊNIO') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.particular == 1));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.particular == 1)
        setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento && fat.forma_pagamento != 'CONVÊNIO'));
        localarray = x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento && fat.forma_pagamento != 'CONVÊNIO');
      } else if (tipoatendimento == 'TODOS' && modopagamento == 'PARTICULAR') {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('PARTICULAR')));
        localatendimentos = stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('PARTICULAR'));
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.particular == 1));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.particular == 1);
        setlocalfaturamento(x.filter(fat => fat.forma_pagamento != 'CONVÊNIO'));
        localarray = x.filter(fat => fat.forma_pagamento != 'CONVÊNIO');
      } else if (tipoatendimento == 'TODOS' && modopagamento == 'CONVÊNIO') {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('CONVÊNIO')));
        localatendimentos = stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('CONVÊNIO'));
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.convenio == 1));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.convenio == 1);
        setlocalfaturamento(x.filter(fat => fat.forma_pagamento == 'CONVÊNIO'));
        localarray = x.filter(fat => fat.forma_pagamento == 'CONVÊNIO');
      } else {
        setatendimentos_mes(stateatendimentos_mes);
        localatendimentos = stateatendimentos_mes;
        setprocedimentos_mes(stateprocedimentos_mes);
        localprocedimentos = stateprocedimentos_mes;
        setlocalfaturamento(x);
        localarray = x;
      }
      refreshChart(localatendimentos, localprocedimentos, localarray);
    } else {
      // filtro para todas as consultas (particulares e convênio).
      console.log('FILTRANDO POR PROFISSIONAL: ' + usuario);
      if (tipoatendimento == 'CONSULTAS' && modopagamento == 'TODAS') {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => cons.id_profissional == usuario));
        localatendimentos = stateatendimentos_mes.filter(cons => cons.id_profissional == usuario);
        setprocedimentos_mes([]);

        getfaturamentoprofissional(localatendimentos, [], statelocalfaturamento);
        // setlocalfaturamento(x.filter(fat => fat.atendimento_id != null));

        localarray = x.filter(fat => fat.atendimento_id != null);
        // filtro para consultas de convênio.
      } else if (tipoatendimento == 'CONSULTAS' && modopagamento == 'CONVÊNIO') {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('CONVÊNIO') && cons.id_profissional == usuario));
        localatendimentos = stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('CONVÊNIO') && cons.id_profissional == usuario);
        setprocedimentos_mes([]);

        getfaturamentoprofissional(localatendimentos, [], statelocalfaturamento);
        // setlocalfaturamento(x.filter(fat => fat.atendimento_id != null && fat.forma_pagamento == 'CONVÊNIO'));

        localarray = x.filter(fat => fat.atendimento_id != null && fat.forma_pagamento == 'CONVÊNIO');
        // filtro para consultas particulares.
      } else if (tipoatendimento == 'CONSULTAS' && modopagamento == 'PARTICULAR') {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('PARTICULAR') && cons.id_profissional == usuario));
        localatendimentos = stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('PARTICULAR') && cons.id_profissional == usuario);
        setprocedimentos_mes([]);

        // setlocalfaturamento(x.filter(fat => fat.atendimento_id != null && fat.forma_pagamento != 'CONVÊNIO'));
        getfaturamentoprofissional(localatendimentos, [], statelocalfaturamento);

        localarray = x.filter(fat => fat.atendimento_id != null && fat.forma_pagamento != 'CONVÊNIO');
        // filtro para todos os procedimentos (particulares e convênios).
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento == 0 && modopagamento == 'TODAS') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.id_profissional_executante == usuario));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.id_profissional_executante == usuario);

        // setlocalfaturamento(x.filter(fat => fat.procedimento_id != null));
        getfaturamentoprofissional([], localprocedimentos, statelocalfaturamento);

        localarray = x.filter(fat => fat.procedimento_id != null);
        // filtro para todos procedimentos de convênio.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento == 0 && modopagamento == 'CONVÊNIO') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.convenio == 1 && proc.id_profissional_executante == usuario));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.convenio == 1 && proc.id_profissional_executante == usuario);

        // setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.forma_pagamento == 'CONVÊNIO'));
        getfaturamentoprofissional([], localprocedimentos, statelocalfaturamento);

        localarray = x.filter(fat => fat.procedimento_id != null && fat.forma_pagamento == 'CONVÊNIO');
        // filtro para todos os procedimentos particulares.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento == 0 && modopagamento == 'PARTICULAR') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.particular == 1 && proc.id_profissional_executante == usuario));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.particular == 1 && proc.id_profissional_executante == usuario);

        // setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.forma_pagamento != 'CONVÊNIO'));
        getfaturamentoprofissional([], localprocedimentos, statelocalfaturamento);

        localarray = x.filter(fat => fat.procedimento_id != null && fat.forma_pagamento != 'CONVÊNIO');
        // filtro para um determinado procedimento, convênio ou particular.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento != 0 && modopagamento == 'TODAS') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.id_profissional_executante == usuario));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.id_profissional_executante == usuario);

        // setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento));
        getfaturamentoprofissional([], localprocedimentos, statelocalfaturamento);

        localarray = x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento);
        // filtro para um determinado procedimento, convênio.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento != 0 && modopagamento == 'CONVÊNIO') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.convenio == 1 && proc.id_profissional_executante == usuario));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.convenio == 1 && proc.id_profissional_executante == usuario);

        // setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento && fat.forma_pagamento == 'CONVÊNIO'));
        getfaturamentoprofissional([], localprocedimentos, statelocalfaturamento);

        localarray = x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento && fat.forma_pagamento == 'CONVÊNIO');
        // filtro para um determinado procedimento, particular.
      } else if (tipoatendimento == 'PROCEDIMENTOS' && selectedprocedimento != 0 && modopagamento != 'CONVÊNIO') {
        setatendimentos_mes([]);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.particular == 1 && proc.id_profissional_executante == usuario));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.nome_exame == selectedprocedimento && proc.particular == 1 && proc.id_profissional_executante == usuario);

        // setlocalfaturamento(x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento && fat.forma_pagamento != 'CONVÊNIO'));
        getfaturamentoprofissional([], localprocedimentos, statelocalfaturamento);

        localarray = x.filter(fat => fat.procedimento_id != null && fat.nome_tuss == selectedprocedimento && fat.forma_pagamento != 'CONVÊNIO');
      } else if (tipoatendimento == 'TODOS' && modopagamento == 'PARTICULAR') {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('PARTICULAR') && cons.id_profissional == usuario));
        localatendimentos = stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('PARTICULAR') && cons.id_profissional == usuario);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.particular == 1 && proc.id_profissional_executante == usuario));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.particular == 1 && proc.id_profissional_executante == usuario);

        // setlocalfaturamento(x.filter(fat => fat.forma_pagamento != 'CONVÊNIO'));
        getfaturamentoprofissional(localatendimentos, localprocedimentos, statelocalfaturamento);

        localarray = x.filter(fat => fat.forma_pagamento != 'CONVÊNIO');
      } else if (tipoatendimento == 'TODOS' && modopagamento == 'CONVÊNIO') {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('CONVÊNIO') && cons.id_profissional == usuario));
        localatendimentos = stateatendimentos_mes.filter(cons => JSON.parse(cons.faturamento_codigo_procedimento).tag_consulta.includes('CONVÊNIO') && cons.id_profissional == usuario);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.convenio == 1 && proc.id_profissional_executante == usuario));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.convenio == 1 && proc.id_profissional_executante == usuario);

        // setlocalfaturamento(x.filter(fat => fat.forma_pagamento == 'CONVÊNIO'));
        getfaturamentoprofissional(localatendimentos, localprocedimentos, statelocalfaturamento);

        localarray = x.filter(fat => fat.forma_pagamento == 'CONVÊNIO');
      } else {
        setatendimentos_mes(stateatendimentos_mes.filter(cons => cons.id_profissional == usuario));
        localatendimentos = stateatendimentos_mes.filter(cons => cons.id_profissional == usuario);
        setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.id_profissional_executante == usuario));
        localprocedimentos = stateprocedimentos_mes.filter(proc => proc.id_profissional_executante == usuario);

        // setlocalfaturamento(x);
        getfaturamentoprofissional(localatendimentos, localprocedimentos, statelocalfaturamento);

        localarray = x;
      }
      refreshChart(localatendimentos, localprocedimentos, localarray);
    }
  }

  const [selecteddate, setselecteddate] = useState(moment().format('MM-YYYY'));
  const [processando, setprocessando] = useState(0);
  useEffect(() => {
    // eslint-disable-next-line
    if (pagina == 'FATURAMENTO') {
      console.log('PÁGINA DE FATURAMENTO');
      localStorage.setItem('objeto_usuario', 'todos');
      setprocessando(0);
      loadAcessos();
      loadOperadoras();
      loadProcedimentos();
      loadTuss();
      filtraregistrosconsultas(moment().format('MM-YYYY'));
      filtraregistrosprocedimentos(moment().format('MM-YYYY'));
      getallfaturamento(); // para montar o gráfico em linha.
      setTimeout(() => {
        loadfaturamentosmes(moment().format('MM-YYYY'));
        document.getElementById("inputMesFaturamento").value = moment().format('MM-YYYY');
      }, 4000);
    }
    // eslint-disable-next-line
  }, [pagina]);

  // acessos dos usuários (profissionais) cadastrados aos diversos clientes (consultórios e clínicas) registrados no sistema.
  const [acessos, setacessos] = useState([]);
  const loadAcessos = () => {
    axios
      .get(html + "list_todos_acessos")
      .then((response) => {
        let x = response.data.rows;
        setacessos(x.filter(item => item.id_cliente == cliente.id_cliente));
        console.log(x.filter(item => item.id_cliente == cliente.id_cliente));
      });
  }

  // FATURAMENTO - OPERADORAS DE SAÚDE //
  // carregando procedimentos da tabela TUSS.
  const [listatuss, setlistatuss] = useState([]);
  const [arraylistatuss, setarraylistatuss] = useState([]);
  const loadTuss = () => {
    axios.get(html + 'all_tabela_tuss').then((response) => {
      setarraylistatuss(response.data.rows);
      setlistatuss(response.data.rows);
    })
  };

  // cadastro de operadoras de saúde.
  const loadOperadoras = () => {
    axios.get(html + 'all_operadoras').then((response) => {
      setoperadoras(response.data.rows);
    })
  };

  const insertOperadora = (imagem) => {
    let obj = {
      nome_operadora: document.getElementById("inputNomeOperadora").value.toUpperCase(),
      registro_ans: document.getElementById("inputRegistroAns").value.toUpperCase(),
      telefone: document.getElementById("inputTelefone").value.toUpperCase(),
      email: document.getElementById("inputEmail").value,
      codigo_prestador: document.getElementById("inputCodigoPrestador").value.toUpperCase(),
      logo_operadora: imagem,
      id_cliente: cliente.id_cliente,
    }
    axios.post(html + 'insert_operadora', obj).then(() => {
      console.log('OPERADORA REGISTRADA COM SUCESSO.');
      loadOperadoras();
      loadProcedimentos();
      setformoperadora(0);
    })
  }

  const updateOperadora = (item, imagem) => {
    let obj = {
      nome_operadora: document.getElementById("inputNomeOperadora").value.toUpperCase(),
      registro_ans: document.getElementById("inputRegistroAns").value.toUpperCase(),
      telefone: document.getElementById("inputTelefone").value.toUpperCase(),
      email: document.getElementById("inputEmail").value,
      codigo_prestador: document.getElementById("inputCodigoPrestador").value.toUpperCase(),
      logo_operadora: imagem,
      id_cliente: cliente.id_cliente
    }
    axios.post(html + 'update_operadora/' + item.id, obj).then(() => {
      console.log('OPERADORA ATUALIZADA COM SUCESSO.');
      setTimeout(() => {
        loadOperadoras();
      }, 2000);
      setformoperadora(0);
    })
  }

  const deleteOperadora = (item) => {
    axios.get(html + 'delete_operadora/' + item.id).then(() => {
      console.log('OPERADORA EXCLUÍDA COM SUCESSO');
      loadOperadoras();
      setformoperadora(0);
    })
  }

  function ListOperadoras() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '30vh', overflowX: 'hidden' }}>
        <div
          className="button"
          id='cabecalho lista de operadoras'
          style={{
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: -20,
            backgroundColor: 'transparent',
          }}>
          <div className="button" style={{ width: '20vw', backgroundColor: 'transparent' }}>{'NOME DA OPERADORA'}</div>
          <div className="button" style={{ width: '10vw', backgroundColor: 'transparent' }}>{'REGISTRO ANS'}</div>
          <div className="button" style={{ width: '10vw', backgroundColor: 'transparent' }}>{'TELEFONE'}</div>
          <div className="button" style={{ width: '10vw', backgroundColor: 'transparent' }}>{'E-MAIL'}</div>
          <div className="button" style={{ width: '10vw', backgroundColor: 'transparent' }}>{'CÓDIGO DO PRESTADOR'}</div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className="button" style={{ width: 50, backgroundColor: 'transparent' }}>{''}</div>
            <div className="button" style={{ width: 50, backgroundColor: 'transparent' }}>{''}</div>
          </div>
        </div>
        {operadoras.filter(item => item.id_cliente == cliente.id_cliente).map(item => (
          <div
            key={Math.random()}
            className='button cor1'
            style={{
              display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
              borderRadius: 5,
            }}
            onClick={() => {
              setselectedoperadora(item);
            }}
          >
            <div className={selectedoperadora == item ? 'button-selected' : 'button'}
              style={{
                width: '20vw',
              }}>
              {item.nome_operadora}
            </div>
            <div className="button" style={{ width: '10vw', backgroundColor: 'transparent' }}>{item.registro_ans}</div>
            <div className="button" style={{ width: '10vw', backgroundColor: 'transparent' }}>{item.telefone}</div>
            <div className="button" style={{ width: '10vw', backgroundColor: 'transparent' }}>{item.email}</div>
            <div className="button" style={{ width: '10vw', backgroundColor: 'transparent' }}>{item.codigo_prestador}</div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div className="button green" style={{ width: 50 }}
                onClick={() => {
                  setselectedoperadora(item);
                  setformoperadora(2);
                  setTimeout(() => {
                    const img = new Image();
                    img.src = item.logo_operadora;
                    img.onload = function () {
                      let canvas = document.getElementById('canvas');
                      canvas.style.backgroundColor = 'white';
                      canvas.height = img.height;
                      canvas.width = img.width;
                      setTimeout(() => {
                        canvas.getContext('2d').drawImage(img, 0, 0);
                      }, 2000);
                    }
                  }, 1000);
                }}
              >
                <img
                  alt=""
                  src={editar}
                  style={{ width: 25, height: 25 }}
                ></img>
              </div>
              <div className="button red" style={{ width: 50 }}
                onClick={(e) => {
                  modal(setdialogo, 'TEM CERTEZA QUE DESEJA EXCLUIR A OPERADORA ' + item.nome_operadora + '?', deleteOperadora, item);
                  e.stopPropagation();
                }}
              >
                <img
                  alt=""
                  src={deletar}
                  style={{ width: 25, height: 25 }}
                ></img>
              </div>
            </div>
          </div>
        ))}
        <div className="button green"
          style={{ width: 50, alignSelf: 'center' }}
          onClick={() => setformoperadora(1)}
        >
          <img
            alt=""
            src={novo}
            style={{ width: 20, height: 20 }}
          ></img>
        </div>
      </div>
    )
  }

  function ViewOperadoras() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center' }}>
          <div className="text2" style={{ fontSize: 22 }}>LISTA DE OPERADORAS CADASTRADAS</div>
        </div>
        <ListOperadoras></ListOperadoras>
        <FormOperadoras></FormOperadoras>
        <div id='btnviewprocedimentos'
          className={viewprocedimentos == 0 ? "button" : "button-selected"}
          style={{
            display: selectedoperadora.nome_operadora != undefined ? 'flex' : 'none',
            width: '30vw', alignSelf: 'center', padding: 20
          }}
          onClick={() => {
            if (viewprocedimentos == 0) {
              setviewprocedimentos(1)
            } else {
              setviewprocedimentos(0);
            }
          }}>
          {viewprocedimentos == 0 ?
            'VER PROCEDIMENTOS CADASTRADOS PARA A OPERADORA ' + selectedoperadora.nome_operadora :
            'OCULTAR PROCEDIMENTOS CADASTRADOS PARA A OPERADORA ' + selectedoperadora.nome_operadora}
        </div>
        <ViewProcedimentos></ViewProcedimentos>
      </div>
    )
  }

  const [formoperadora, setformoperadora] = useState(0); // 1 = inserir operadora. 2 = atualizar operadora.
  function FormOperadoras() {
    return (
      <div className="fundo"
        style={{ display: formoperadora != 0 ? 'flex' : 'none', flexDirection: 'column', justifyContent: 'center' }}
        onClick={() => setformoperadora(0)}
      >
        <div className="janela scroll cor2"
          style={{ height: '90vh' }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">NOME DA OPERADORA</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="NOME DA OPERADORA"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "NOME DA OPERADORA")}
              type="text"
              id="inputNomeOperadora"
              defaultValue={formoperadora == 2 ? selectedoperadora.nome_operadora : ''}
              maxLength={200}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw" }}
            ></input>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">REGISTRO ANS</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="REGISTRO ANS"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "REGISTRO ANS")}
              type="text"
              id="inputRegistroAns"
              defaultValue={formoperadora == 2 ? selectedoperadora.registro_ans : ''}
              maxLength={200}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw" }}
            ></input>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">TELEFONE DA OPERADORA</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="TELEFONE DA OPERADORA"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "TELEFONE DA OPERADORA")}
              type="text"
              id="inputTelefone"
              defaultValue={formoperadora == 2 ? selectedoperadora.telefone : ''}
              maxLength={200}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw" }}
            ></input>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">EMAIL DA OPERADORA</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="E-MAIL"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "E-MAIL")}
              type="text"
              id="inputEmail"
              defaultValue={formoperadora == 2 ? selectedoperadora.email : ''}
              maxLength={200}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", textTransform: 'none' }}
            ></input>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">CÓDIGO DO PRESTADOR NA OPERADORA</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="CÓDIGO DO PRESTADOR NA OPERADORA"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "CÓDIGO DO PRESTADOR NA OPERADORA")}
              type="text"
              id="inputCodigoPrestador"
              defaultValue={formoperadora == 2 ? selectedoperadora.codigo_prestador : ''}
              maxLength={200}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw" }}
            ></input>
          </div>
          <input className='button' id="uploader" type="file"
            style={{ display: 'none' }}
            onChange={() => {
              document.getElementById('canvas').getContext('2d').clearRect(0, 0, 300, 150);
              localStorage.setItem("imagem", document.getElementById("uploader").files[0]);
              const myFile = document.getElementById("uploader").files[0];
              const img = new Image();
              img.src = URL.createObjectURL(myFile);
              img.onload = () => {
                document.getElementById('canvas').style.backgroundColor = 'white';
                document.getElementById('canvas').width = img.width;
                document.getElementById('canvas').height = img.height;
                document.getElementById('canvas').getContext('2d').drawImage(img, 0, 0, img.width, img.height);
              }
            }}
          >
          </input>
          <div className="button" for="uploader" style={{ paddingLeft: 20, paddingRight: 20 }}
            onClick={() => document.getElementById('uploader').click()}
          >
            SELECIONE A LOGO
          </div>
          <canvas id="canvas"
            style={{ backgroundColor: 'white', borderRadius: 5, margin: 10, marginTop: 5, alignSelf: 'center', maxWidth: '50vw' }}>
          </canvas>
          <div className="button green"
            onClick={() => {
              if (formoperadora == 1) {
                let imagem = document.getElementById('canvas').toDataURL('image/jpeg');
                insertOperadora(imagem);
              } else {
                let imagem = document.getElementById('canvas').toDataURL('image/jpeg');
                updateOperadora(selectedoperadora, imagem);
              }
            }}
          >
            <img
              alt=""
              src={salvar}
              style={{ width: 20, height: 20 }}
            >
            </img>
          </div>
        </div>
      </div>
    )
  }

  // FATURAMENTO - OPERADORAS DE SAÚDE //
  // cadastro de procedimentos.
  const loadProcedimentos = () => {
    axios.get(html + 'all_procedimentos').then((response) => {
      setprocedimentos(response.data.rows);
    })
  };

  const insertProcedimento = () => {
    let obj = {
      id_operadora: selectedoperadora.id,
      nome_operadora: selectedoperadora.nome_operadora,
      tuss_codigo: document.getElementById("inputCodigoTuss").value.toUpperCase(),
      tuss_terminologia: document.getElementById("inputTerminologia").value.toUpperCase(),
      tuss_rol_ans: document.getElementById("inputRolAns").value.toUpperCase(),
      tuss_rol_ans_descricao: document.getElementById("inputTerminologia").value.toUpperCase(),
      valor: document.getElementById("inputValor").value.toUpperCase(),
      fator_aumento: document.getElementById("inputFatorAumento").value.toUpperCase(),
      fator_reducao: document.getElementById("inputFatorReducao").value.toUpperCase(),
      valor_absoluto_aumento: document.getElementById("inputValorAbsolutoAumento").value.toUpperCase(),
      valor_absoluto_reducao: document.getElementById("inputValorAbsolutoReducao").value.toUpperCase(),
      obs: document.getElementById("inputObs").value.toUpperCase(),
      id_cliente: cliente.id_cliente,
      valor_part: document.getElementById("inputValorPart").value.toUpperCase(),
    }
    axios.post(html + 'insert_procedimento', obj).then(() => {
      console.log('PROCEDIMENTO REGISTRADO COM SUCESSO.');
      loadProcedimentos();
      setformprocedimento(0);
    });
  }

  const updateProcedimento = () => {
    let obj = {
      id_operadora: selectedoperadora.id,
      nome_operadora: selectedoperadora.nome_operadora,
      tuss_codigo: document.getElementById("inputCodigoTuss").value.toUpperCase(),
      tuss_terminologia: document.getElementById("inputTerminologia").value.toUpperCase(),
      tuss_rol_ans: document.getElementById("inputRolAns").value.toUpperCase(),
      tuss_rol_ans_descricao: document.getElementById("inputTerminologia").value.toUpperCase(),
      valor: document.getElementById("inputValor").value.toUpperCase(),
      fator_aumento: document.getElementById("inputFatorAumento").value.toUpperCase(),
      fator_reducao: document.getElementById("inputFatorReducao").value.toUpperCase(),
      valor_absoluto_aumento: document.getElementById("inputValorAbsolutoAumento").value.toUpperCase(),
      valor_absoluto_reducao: document.getElementById("inputValorAbsolutoReducao").value.toUpperCase(),
      obs: document.getElementById("inputObs").value.toUpperCase().toUpperCase(),
      id_cliente: cliente.id_cliente,
      valor_part: document.getElementById("inputValorPart").value.toUpperCase(),
    }
    axios.post(html + 'update_procedimento/' + selectedprocedimento.id, obj).then(() => {
      console.log('PROCEDIMENTO ATUALIZADO COM SUCESSO.');
      loadProcedimentos();
      setformprocedimento(0);
    })
  }

  const deleteProcedimento = (item) => {
    axios.get(html + 'delete_procedimento/' + item.id).then(() => {
      console.log('PROCEDIMENTO EXCLUÍDO COM SUCESSO');
      setformprocedimento(0);
      loadProcedimentos();
    })
  }

  function ListProcedimentos() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '30vh', overflowX: 'hidden' }}>
        <div id='cabecalho lista de procedimentos'
          className="button"
          style={{
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: -5,
            backgroundColor: 'transparent'
          }}>
          <div className='text2' style={{ width: '10vw' }}>{'NOME DA OPERADORA'}</div>
          <div className='text2' style={{ width: '10vw' }}>{'CÓDIGO TUSS'}</div>
          <div className='text2' style={{ width: '25vw' }}>{'TERMINOLOGIA'}</div>
          <div className='text2' style={{ width: '25vw' }}>{'DESCRIÇÃO'}</div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className='text2' style={{ width: 50 }}>{''}</div>
            <div className='text2' style={{ width: 50 }}>{''}</div>
          </div>

        </div>
        {procedimentos.filter(item => item.id_operadora == selectedoperadora.id).map(item => (
          <div
            className="button cor1"
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
            onClick={() => {
              setselectedprocedimento(item);
              setformprocedimento(2);
            }}
          >
            <div className="button" style={{ width: '10vw' }}>{item.nome_operadora}</div>
            <div className='text2' style={{ width: '10vw' }}>{item.tuss_codigo}</div>
            <div style={{ display: 'flex', flexDirection: 'row', width: '25vw', justifyContent: 'flex-start' }}>
              <div className='text2' style={{ justifyContent: 'flex-start', textAlign: 'left', }}>{item.tuss_terminologia.toUpperCase()}</div>
            </div>
            <div className='text2' style={{ width: '25vw' }}>{item.rol_ans_descricao}</div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div className="button green" style={{ width: 50 }}
                onClick={(e) => {
                  setselectedprocedimento(item);
                  setformprocedimento(2);
                  e.stopPropagation();
                }}
              >
                <img
                  alt=""
                  src={editar}
                  style={{ width: 25, height: 25 }}
                ></img>
              </div>
              <div className="button red" style={{ width: 50 }}
                onClick={(e) => {
                  modal(setdialogo, 'TEM CERTEZA QUE DESEJA EXCLUIR O PROCEDIMENTO ' + item.rol_ans_descricao + '?', deleteProcedimento, item);
                  e.stopPropagation();
                }}
              >
                <img
                  alt=""
                  src={deletar}
                  style={{ width: 25, height: 25 }}
                ></img>
              </div>
            </div>
          </div>
        ))}
        <div className="button green"
          style={{ width: 50, alignSelf: 'center' }}
          onClick={() => setformprocedimento(1)}
        >
          <img
            alt=""
            src={novo}
            style={{ width: 20, height: 20 }}
          ></img>
        </div>
      </div>
    )
  }

  const [tipoatendimento, settipoatendimento] = useState('TODOS');
  const [formapagamento, setformapagamento] = useState('TODAS');
  const SelecionaProcedimentos = useCallback(() => {
    return (
      <div
        id="scroll procedimentos faturamento"
        className='scroll'
        style={{
          display: tipoatendimento == 'PROCEDIMENTOS' ? 'flex' : 'none',
          flexDirection: 'row',
          width: '80vw',
          margin: 10,
          alignContent: 'flex-start',
          alignSelf: 'center',
          overflowX: 'scroll',
          overflowY: 'hidden',
        }}
      >
        {procedimentos.filter(item => item.id_cliente == cliente.id_cliente).map(item => (
          <div
            key={'exame: ' + item.id}
            id={'btn procedimento faturamento ' + item.id}
            className={selectedprocedimento == item.tuss_rol_ans_descricao ? 'button-selected' : 'button'}
            style={{ display: 'flex', width: 150, minWidth: 150, paddingLeft: 30, paddingRight: 30 }}
            title={item.tuss_rol_ans_descricao}
            onClick={() => {
              setprocedimentos_mes(stateprocedimentos_mes.filter(proc => proc.nome_exame == item.tuss_rol_ans_descricao));
              setselectedprocedimento(item.tuss_rol_ans_descricao);
              localStorage.setItem('procedimento_selecionado', item.tuss_rol_ans_descricao);
              refreshfaturamentomes();
              localStorage.setItem('procedimento', item.tuss_rol_ans_descricao);
              localStorage.setItem('codigo_tuss', item.tuss_codigo);
              selector("scroll procedimentos faturamento", 'btn procedimento faturamento ' + item.id, 100);
            }}
          >
            {item.tuss_rol_ans_descricao.length > 30 ? item.tuss_rol_ans_descricao.slice(0, 30) + '...' : item.tuss_rol_ans_descricao}
          </div>
        ))}
        <div
          key={'exame: todos'}
          id={'btn procedimento faturamento todos'}
          className='button'
          style={{ display: 'flex', width: 150, minWidth: 150, paddingLeft: 30, paddingRight: 30 }}
          onClick={() => {
            setprocessando(0);
            setprocedimentos_mes(stateprocedimentos_mes);
            filtraregistrosconsultas(selecteddate);
            filtraregistrosprocedimentos(selecteddate);
            loadfaturamentosmes(selecteddate);
            // getallfaturamento();
            localStorage.setItem('procedimento', '');
            localStorage.setItem('codigo_tuss', '');
            selector("scroll procedimentos faturamento", 'btn procedimento faturamento todos', 100);
          }}
        >
          {'TODOS'}
        </div>
      </div>
    )
    // eslint-disable-next-line
  }, [procedimentos, tipoatendimento, selecteddate, selectedprocedimento]);

  const [viewprocedimentos, setviewprocedimentos] = useState(0);
  function ViewProcedimentos() {
    return (
      <div style={{ display: viewprocedimentos == 1 ? 'flex' : 'none', flexDirection: 'column', justifyContent: 'center' }}>
        <div className="text2" style={{ fontSize: 22, marginTop: 15 }}>{'PROCEDIMENTOS CADASTRADOS PARA A OPERADORA ' + selectedoperadora.nome_operadora}</div>
        <ListProcedimentos></ListProcedimentos>
        <FormProcedimentos></FormProcedimentos>
      </div>
    )
  }

  const [viewtussselector, setviewtussselector] = useState(0);
  const [tussselected, settussselected] = useState([]);
  function FormTussSelector() {
    return (
      <div className="fundo"
        style={{
          display: viewtussselector == 1 ? 'flex' : 'none',
          flexDirection: 'column', justifyContent: 'center'
        }}
        onClick={() => setviewtussselector(0)}
      >
        <div className="janela scroll cor2"
          style={{ height: '90vh', width: '80vw' }}
          onClick={(e) => e.stopPropagation()}
        >
          {Filter("filtrarProcedimento", setarraylistatuss, listatuss, 'item.rol_ans_descricao')}
          {arraylistatuss.map(item => (
            <div
              className="button"
              key={Math.random()}
              style={{ width: 'calc(100% - 20px)', padding: 10, display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}
              onClick={() => {
                settussselected(item);
                setviewtussselector(0);
                setTimeout(() => {
                  document.getElementById("inputCodigoTuss").value = item.codigo;
                  document.getElementById("inputTerminologia").value = item.terminologia;
                  document.getElementById("inputRolAns").value = item.rol_ans;
                  document.getElementById("inputRolAnsDescricao").value = item.rol_ans_descricao;
                }, 1000);
              }}>
              <div className="button red" style={{ margin: 10, marginLeft: -2.5, width: 150, minWidth: 150 }}>{item.codigo}</div>
              <div style={{ textAlign: 'left' }}>{item.rol_ans_descricao}</div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const [formprocedimento, setformprocedimento] = useState(0); // 1 = inserir operadora. 2 = atualizar operadora.
  function FormProcedimentos() {
    return (
      <div className="fundo"
        style={{ display: formprocedimento != 0 ? 'flex' : 'none', flexDirection: 'column', justifyContent: 'center' }}
        onClick={() => setformprocedimento(0)}
      >
        <div className="janela scroll cor2"
          style={{ height: '90vh' }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className='button' style={{ width: '100%' }} id="procedimento_selector" onClick={() => setviewtussselector(1)}>
              {tussselected.codigo != undefined ? tussselected.codigo + ' - ' + tussselected.rol_ans_descricao : 'SELECIONE'}
            </div>
            <FormTussSelector></FormTussSelector>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">CÓDIGO TUSS</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="CÓDIGO TUSS"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "CÓDIGO TUSS")}
              type="text"
              id="inputCodigoTuss"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.tuss_codigo : ''}
              maxLength={200}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
            <div className="text1">TERMINOLOGIA</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="TERMINOLOGIA"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "TERMINOLOGIA")}
              type="text"
              id="inputTerminologia"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.tuss_terminologia : ''}
              maxLength={200}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
            <div className="text1">ROL ANS</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="ROL ANS"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "ROL ANS")}
              type="text"
              id="inputRolAns"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.tuss_rol_ans : ''}
              maxLength={200}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
            <div style={{ display: 'none' }} className="text1">ROL ANS DESCRIÇÃO</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="ROL ANS"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "ROL ANS")}
              type="text"
              id="inputRolAnsDescricao"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.tuss_rol_ans_descricao : ''}
              maxLength={200}
              style={{ display: 'none', margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
            <div className="text1">VALOR PELO CONVÊNIO</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="VALOR"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "VALOR (R$)")}
              type="text"
              id="inputValor"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.valor : ''}
              maxLength={200}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
            <div className="text1">FATOR DE AUMENTO</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="FATOR DE AUMENTO"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "FFATOR DE AUMENTO")}
              type="text"
              id="inputFatorAumento"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.fator_aumento : ''}
              maxLength={2}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">FATOR DE REDUÇÃO</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="FATOR DE REDUÇÃO"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "FATOR DE REDUÇÃO")}
              type="text"
              id="inputFatorReducao"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.fator_reducao : ''}
              maxLength={2}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">VALOR ABSOLUTO DE AUMENTO</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="VALOR ABSOLUTO DE AUMENTO"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "VALOR ABSOLUTO DE AUMENTO")}
              type="text"
              id="inputValorAbsolutoAumento"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.valor_absoluto_aumento : ''}
              maxLength={2}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">VALOR ABSOLUTO DE REDUÇÃO</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="VALOR ABSOLUTO DE REDUÇÃO"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "VALOR ABSOLUTO DE REDUÇÃO")}
              type="text"
              id="inputValorAbsolutoReducao"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.valor_absoluto_reducao : ''}
              maxLength={2}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
          </div>
          <div className="text1">VALOR PARTICULAR</div>
          <input
            className="input"
            autoComplete="off"
            placeholder="VALOR"
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "VALOR (R$)")}
            type="text"
            id="inputValorPart"
            defaultValue={formprocedimento == 2 ? selectedprocedimento.valor_part : ''}
            maxLength={200}
            style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
          ></input>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="text1">OBSERVAÇÕES</div>
            <input
              className="input"
              autoComplete="off"
              placeholder="OBSERVAÇÕES"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "OBSERVAÇÕES")}
              type="text"
              id="inputObs"
              defaultValue={formprocedimento == 2 ? selectedprocedimento.obs : ''}
              maxLength={2000}
              style={{ margin: 5, width: window.innerWidth < 426 ? "100%" : "30vw", alignSelf: 'center' }}
            ></input>
          </div>
          <div
            id="botao_salvar_procedimento"
            className="button green"
            onClick={() => {
              if (formprocedimento == 1) {
                checkinput('input', settoast, ["inputTerminologia"], "botao_salvar_procedimento", insertProcedimento, []);
              } else {
                console.log(selectedprocedimento);
                checkinput('input', settoast, ["inputTerminologia"], "botao_salvar_procedimento", updateProcedimento, []);
              }
            }}
          >
            <img
              alt=""
              src={salvar}
              style={{ width: 20, height: 20 }}
            >
            </img>
          </div>
        </div>
      </div>
    )
  }

  const [menufaturamento, setmenufaturamento] = useState('REGISTROS DE FATURAMENTO');
  let opcoesmenufaturamento = [
    'REGISTROS DE FATURAMENTO',
    'CADASTRO DE OPERADORAS E PROCEDIMENTOS',
  ]
  function MenuFaturamento() {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: 5 }}>
        <div id="botão para sair da tela de faturamento"
          className="button-yellow"
          style={{ maxHeight: 50, maxWidth: 50, alignSelf: 'center' }}
          onClick={() => {
            setpagina(0);
            history.push("/");
          }}>
          <img
            alt=""
            src={back}
            style={{ width: 30, height: 30 }}
          ></img>
        </div>
        {opcoesmenufaturamento.map((item) => (
          <div className={menufaturamento == item ? "button-selected" : "button"}
            onClick={() => setmenufaturamento(item)}
            style={{ width: 250 }}
          >
            {item}
          </div>
        ))}
      </div>
    )
  }

  let calendariomensal = [
    moment().subtract(3, 'months').format('MM-YYYY'),
    moment().subtract(2, 'months').format('MM-YYYY'),
    moment().subtract(1, 'month').format('MM-YYYY'),
    moment().format('MM-YYYY'),
    moment().add(1, 'month').format('MM-YYYY'),
    moment().add(2, 'months').format('MM-YYYY'),
    moment().add(3, 'months').format('MM-YYYY'),
  ]

  // eslint-disable-next-line
  const [stateatendimentos_mes, setstateatendimentos_mes] = useState([]);
  const [atendimentos_mes, setatendimentos_mes] = useState([]);
  const filtraregistrosconsultas = (data) => {
    axios.get(html + "list_faturamento_clinicas_mes/" + cliente.id_cliente + "/" + data).then((response) => {
      let x = response.data.rows;
      x.map(item => {
        if (item.faturamento_codigo_procedimento !== null && item.faturamento_codigo_procedimento !== '' && item.faturamento_codigo_procedimento.length > 10) {
          console.log('OBJETO DE TAG EM CONFORMIDADE.');
        } else if (item.faturamento_codigo_procedimento == 'PARTICULAR') {
          console.log('TAG ANTIGA PARTICULAR');
          let obj = {
            tag_consulta: 'PARTICULAR',
            tag_cor: 'green',
            tempo_consulta: null,
            id_cliente: item.id_cliente,
            id_usuario: item.id_profissinal,
          }
          item.faturamento_codigo_procedimento = JSON.stringify(obj);
        } else if (item.faturamento_codigo_procedimento == 'CONVÊNIO') {
          let obj = {
            tag_consulta: 'CONVÊNIO',
            tag_cor: 'blue',
            tempo_consulta: null,
            id_cliente: item.id_cliente,
            id_usuario: item.id_profissinal,
          }
          item.faturamento_codigo_procedimento = JSON.stringify(obj);
        } else {
          let obj = {
            tag_consulta: 'TAG INDEFINIDA',
            tag_cor: 'gray',
            tempo_consulta: null,
            id_cliente: item.id_cliente,
            id_usuario: item.id_profissinal,
          }
          item.faturamento_codigo_procedimento = JSON.stringify(obj);
        }
        return null;
      })
      localStorage.setItem('fat_atendimentos_mes', JSON.stringify(x));
      setstateatendimentos_mes(x);
      setatendimentos_mes(x);
    });
  }

  const [stateprocedimentos_mes, setstateprocedimentos_mes] = useState([]);
  const [procedimentos_mes, setprocedimentos_mes] = useState([]);
  const filtraregistrosprocedimentos = (data) => {
    axios.get(html + "list_faturamento_procedimentos_mes/" + cliente.id_cliente + "/" + data).then((response) => {
      let x = response.data.rows;
      localStorage.setItem('fat_procedimentos_mes', JSON.stringify(x));
      setstateprocedimentos_mes(x);
      setprocedimentos_mes(x);
    });
  }

  function Filtros() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div id='filtros'
          style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <div
            className={tipoatendimento == 'CONSULTAS' ? "button-selected" : "button"}
            style={{ width: 150 }}
            onClick={() => {
              console.log('DATA: ' + selecteddate);
              settipoatendimento('CONSULTAS');
              localStorage.setItem('tipoatendimento', 'CONSULTAS');
              refreshfaturamentomes();
              setTimeout(() => {
                document.getElementById("inputMesFaturamento").value = selecteddate;
              }, 1000);
            }}
          >
            CONSULTAS
          </div>
          <div
            className={tipoatendimento == 'PROCEDIMENTOS' ? "button-selected" : "button"}
            style={{ width: 150 }}
            onClick={() => {
              console.log('DATA: ' + selecteddate);
              settipoatendimento('PROCEDIMENTOS');
              localStorage.setItem('tipoatendimento', 'PROCEDIMENTOS');
              refreshfaturamentomes();
              setTimeout(() => {
                document.getElementById("inputMesFaturamento").value = selecteddate;
              }, 1000);
            }}
          >
            PROCEDIMENTOS
          </div>
          <div
            className={tipoatendimento == 'TODOS' ? "button-selected" : "button"}
            style={{ width: 150 }}
            onClick={() => {
              settipoatendimento('TODOS')
              localStorage.setItem('tipoatendimento', 'TODOS');
              refreshfaturamentomes();
              setTimeout(() => {
                document.getElementById("inputMesFaturamento").value = selecteddate;
              }, 1000);
            }}
          >
            TODOS
          </div>
          <div
            className={formapagamento == 'PARTICULAR' ? "button-selected" : "button"}
            style={{ width: 150 }}
            onClick={() => {
              setformapagamento('PARTICULAR')
              localStorage.setItem('formapagamento', 'PARTICULAR');
              refreshfaturamentomes();
              setTimeout(() => {
                document.getElementById("inputMesFaturamento").value = selecteddate;
              }, 1000);
            }}
          >
            PARTICULAR
          </div>
          <div
            className={formapagamento == 'CONVÊNIO' ? "button-selected" : "button"}
            style={{ width: 150 }}
            onClick={() => {
              setformapagamento('CONVÊNIO')
              localStorage.setItem('formapagamento', 'CONVÊNIO');
              refreshfaturamentomes();
              setTimeout(() => {
                document.getElementById("inputMesFaturamento").value = selecteddate;
              }, 1000);
            }}
          >
            CONVÊNIO
          </div>
          <div
            className={formapagamento == 'TODAS' ? "button-selected" : "button"}
            style={{ width: 150 }}
            onClick={() => {
              setformapagamento('TODAS')
              localStorage.setItem('formapagamento', 'TODAS');
              refreshfaturamentomes();
              setTimeout(() => {
                document.getElementById("inputMesFaturamento").value = selecteddate;
              }, 1000);
            }}
          >
            TODAS
          </div>
          <div className="button" style={{ width: 50, maxWidth: 50, alignSelf: 'center' }} onClick={() => {
            console.log(localStorage.getItem('objeto_usuario'))
            printRelatorioFaturamento()
          }
          }>
            <img
              alt=""
              src={impressora}
              style={{ width: 25, height: 25 }}
            ></img>
          </div>
        </div>
        <ListUsuarios></ListUsuarios>
      </div >
    )
  }

  // lista de profissionais cadastrados para o cliente.
  const [selectedusuario, setselectedusuario] = useState('todos');
  function ListUsuarios() {
    return (
      <div className=" scroll cor2"
        style={{
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start',
          alignSelf: 'center',
          overflowX: 'scroll', overflowY: 'hidden',
          width: '80vw',
        }}
      >
        {acessos.filter(acesso => acesso.id_cliente == cliente.id_cliente).map(acesso => (
          <div id="lista de usuários para filtrar faturamento">
            {usuarios.filter(item => item.tipo_usuario != 'ADMINISTRATIVO' && acesso.id_usuario == item.id_usuario).map(item => (
              <div
                id={"identificação do profissional " + item.id_usuario}
                className={selectedusuario == item.nome_usuario ? "button-selected" : "button"}
                onClick={() => {
                  localStorage.setItem('usuario', item.id_usuario);
                  localStorage.setItem('objeto_usuario', JSON.stringify(item));
                  setselectedusuario(item.nome_usuario);
                  refreshfaturamentomes();
                }}
                style={{
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',
                  width: 200, minWidth: 200,
                  opacity: 0.9,
                  padding: 20,
                  alignContent: 'flex-start',
                  alignItems: 'flex-start',
                }}>
                <div style={{ textAlign: 'left' }}>{item.nome_usuario.substring(0, 15) + '...'}</div>
                <div style={{ textAlign: 'left' }}>{item.conselho + ' - ' + item.n_conselho}</div>
                <div style={{ textAlign: 'left' }}>{item.tipo_usuario}</div>
              </div>
            ))}
          </div>
        ))}
        <div
          onClick={() => {
            localStorage.setItem('usuario', 'todos');
            localStorage.setItem('objeto_usuario', 'todos');
            setselectedusuario('todos');
            refreshfaturamentomes();
          }}
          className={selectedusuario == 'todos' ? 'button-selected' : 'button'}
          style={{
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',
            width: 200, minWidth: 200,
            opacity: 0.9,
            padding: 20,
            alignContent: 'flex-start',
            alignItems: 'flex-start',
          }}
        >
          TODOS
        </div>
      </div>
    )
  }

  const [objfaturamento, setobjfaturamento] = useState(null);
  function ListaDeFaturamentos() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
        <div id="scroll de meses"
          className="scroll cor2"
          style={{
            display: 'flex', flexDirection: 'row', justifyContent: 'flex-start',
            overflowY: 'hidden', overflowX: 'scroll',
            width: '80vw', alignSelf: 'center',
          }}>
          <textarea
            autoComplete="off"
            placeholder="MÊS/ANO"
            className="textarea"
            type="text"
            inputMode="numeric"
            maxLength={10}
            id="inputMesFaturamento"
            title="FORMATO: MM-YYYY"
            onClick={() => document.getElementById("inputMesFaturamento").value = ""}
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "MÊS-ANO")}
            style={{
              flexDirection: "center",
              justifyContent: "center",
              alignSelf: "center",
              width: 150,
              textAlign: "center",
              padding: 5,
              height: 20,
              minHeight: 20,
              maxHeight: 20,
            }}
          ></textarea>
          <div id='botão para buscar por data.'
            className="button red"
            onClick={() => {
              let data = document.getElementById("inputMesFaturamento").value;
              setprocessando(0);
              filtraregistrosconsultas(document.getElementById("inputMesFaturamento").value);
              filtraregistrosprocedimentos(document.getElementById("inputMesFaturamento").value);
              loadfaturamentosmes(document.getElementById("inputMesFaturamento").value);
              // getallfaturamento();
              setselecteddate(document.getElementById("inputMesFaturamento").value);
              setTimeout(() => {
                document.getElementById("inputMesFaturamento").value = data;
              }, 1000);
            }}
            style={{
              borderRadius: 50,
              minWidth: 20,
              width: 20,
              maxWidth: 20,
              minHeight: 20,
              height: 20,
              maxHeight: 20,
              alignSelf: 'center',
              marginLeft: -20,
            }}>
            <img
              alt=""
              src={lupa}
              style={{
                margin: 0,
                height: 20,
                width: 20,
                opacity: 1,
                alignSelf: 'center'
              }}
            ></img>
          </div>
          {calendariomensal.map(item => (
            <div
              id={'btn_datas_faturamento ' + item}
              className={selecteddate == item ? "button-selected" : "button"}
              style={{ width: 200, minHeight: 30, height: 30, maxHeight: 30 }}
              onClick={() => {
                setselecteddate(item);
                setprocessando(0);
                filtraregistrosconsultas(item);
                filtraregistrosprocedimentos(item);
                refreshChart([], [], []);
                setTimeout(() => {
                  loadfaturamentosmes(item);
                  // getallfaturamento();
                }, 2000);

                setTimeout(() => {
                  document.getElementById("inputMesFaturamento").value = item;
                }, 1000);
              }}>
              {item}
            </div>
          ))}
        </div>
        <TotaisFaturamento></TotaisFaturamento>
        <Filtros></Filtros>
        <div>
          {
            atendimentos_mes.sort((a, b) => moment(a.data_inicio) > moment(b.data_inicio) ? 1 : -1).filter(item => item.nome_paciente != 'HORÁRIO BLOQUEADO!').map(item => (
              <div className="button cor1"
                style={{
                  display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '90vw',
                }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                    <div className="button-opaque" style={{
                      display: 'flex', flexDirection: 'column', justifyContent: 'center', width: 300, minWidth: 300,
                      marginRight: 10, alignSelf: 'center',
                    }}>
                      <div style={{ fontSize: 16 }}>{'CONSULTA'}</div>
                      <div>{moment(item.data_inicio).format('DD/MM/YYYY - HH:mm')}</div>
                      <div className="button" style={{
                        width: 200, minWidth: 200, paddingLeft: 20, paddingRight: 20,
                        backgroundColor: item.faturamento_codigo_procedimento !== null && item.faturamento_codigo_procedimento !== '' && item.faturamento_codigo_procedimento.length > 10 ? JSON.parse(item.faturamento_codigo_procedimento).tag_color : 'grey'
                      }}>
                        {item.faturamento_codigo_procedimento !== null && item.faturamento_codigo_procedimento !== '' && item.faturamento_codigo_procedimento.length > 10 ? JSON.parse(item.faturamento_codigo_procedimento).tag_consulta : 'TAG INDEFINIDA'}
                      </div>
                    </div>
                    <div style={{
                      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', textAlign: 'left',
                      alignSelf: 'center',
                    }}>
                      <div style={{ fontSize: 10, opacity: 0.5 }}>
                        {'ID ATENDIMENTO: ' + item.id_atendimento}
                      </div>
                      <div>
                        {'CLIENTE: ' + item.nome_paciente}
                      </div>
                      <div>
                        {'PROFISSIONAL: ' + usuarios.filter(usuario => usuario.id_usuario == item.id_profissional).map(usuario => usuario.nome_usuario)}
                      </div>
                    </div>
                  </div>
                  <div id="faturamento pendente - atendimentos (consultas)"
                    style={{
                      display: allfaturamento.filter(valor => valor.atendimento_id == item.id_atendimento).length < 1 ? 'flex' : 'none',
                      flexDirection: 'column', flexWrap: 'wrap',
                      alignSelf: 'flex-end',
                    }}>
                    <div className="button red" style={{ width: 200, alignSelf: 'flex-end' }}>FATURAMENTO PENDENTE!</div>
                  </div>
                </div>
                <div id="elementos do faturamento particular - atendimentos (consultas)"
                  className="grid"
                  style={{ display: item.faturamento_codigo_procedimento == 'PARTICULAR' ? 'grid' : 'none', width: '100%' }}>
                  {allfaturamento.filter(valor => valor.atendimento_id == item.id_atendimento).sort((a, b) => a.parcela < b.parcela ? -1 : 1).map(valor => (
                    <div className={valor.status_pagamento == 'ABERTO' ? 'button yellow' : valor.status_pagamento == 'VENCIDO' ? 'button red' : 'button green'}
                      onClick={() => {
                        setobjatendimento(item);
                        setobjfaturamento(valor);
                        setvieweditfaturamento(1);
                      }}
                      style={{
                        display: 'flex', flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignContent: 'flex-start',
                        alignItems: 'flex-start',
                        textAlign: 'left',
                      }}>
                      <div style={{ fontSize: 14, textDecoration: 'underline' }}>{valor.forma_pagamento}</div>
                      <div>{'PARCELA: ' + valor.parcela}</div>
                      <div>{'STATUS: ' + valor.status_pagamento}</div>
                      <div>{valor.data_pagamento == null ? 'DATA DO PAGAMENTO: PENDENTE' : 'DATA DO PAGAMENTO: ' + valor.data_pagamento}</div>
                      <div>{'DATA DO VENCIMENTO: ' + valor.data_vencimento}</div>
                      <div style={{ fontSize: 14 }}>{'VALOR: R$ ' + parseFloat(valor.valor_pagamento).toFixed(2)}</div>
                    </div>
                  ))}
                </div>
                <div id="elementos do faturamento convênio - atendimentos (consultas)"
                  className="grid"
                  style={{ display: item.faturamento_codigo_procedimento == 'CONVÊNIO' ? 'grid' : 'none', width: '100%' }}>
                  {allfaturamento.filter(valor => valor.atendimento_id == item.id_atendimento).sort((a, b) => a.parcela < b.parcela ? -1 : 1).map(valor => (
                    <div
                      className={valor.status_pagamento == 'ABERTO' ? 'button yellow' : valor.status_pagamento == 'VENCIDO' ? 'button red' : 'button green'}
                      onClick={() => {
                        setobjatendimento(item);
                        setobjfaturamento(valor);
                      }}
                      style={{
                        display: 'flex', flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignContent: 'flex-start',
                        alignItems: 'flex-start',
                        textAlign: 'left',
                      }}>
                      <div style={{ fontSize: 14, textDecoration: 'underline' }}>{valor.forma_pagamento}</div>
                      <div>{'OPERADORA: ' + operadoras.filter(op => op.id == valor.id_operadora).map(op => op.nome_operadora)}</div>
                      <div>{'STATUS: ' + valor.status_pagamento}</div>
                      <div>{valor.data_pagamento == null ? 'DATA DO PAGAMENTO: PENDENTE' : 'DATA DO PAGAMENTO: ' + valor.data_pagamento}</div>
                      <div>{'DATA DO VENCIMENTO: ' + valor.data_vencimento}</div>
                      <div style={{ fontSize: 14 }}>{'VALOR R$ ' + parseFloat(valor.valor_pagamento).toFixed(2)}</div>
                      <div className="grid2" style={{ marginTop: 10 }}>
                        <div id='confirmar pagamento pela operadora'
                          className="button-green"
                          style={{
                            display: valor.status_pagamento != 'PAGO' ? 'flex' : 'none',
                            height: 100, minHeight: 100,
                          }}
                          onClick={() => updateRegistroProcedimento(valor, 'PAGO', moment().format('DD/MM/YYYY'), parseFloat(valor.valor_pagamento).toFixed(2))}
                        >
                          CONFIRMAR PAGAMENTO PELA OPERADORA
                        </div>
                        <div id='gerarXml - procedimento de convênio'
                          className="button-green"
                          style={{
                            display: 'flex',
                            height: 100, minHeight: 100,
                          }}
                          onClick={() => createxml(dataxmltest)} // SUPER PENDENTE!!!
                        >
                          GERAR XML
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
          }
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <SelecionaProcedimentos></SelecionaProcedimentos>
          {
            procedimentos_mes.sort((a, b) => moment(a.data_exame, 'DD/MM/YYYY - HH:mm') > moment(b.data_exame, 'DD/MM/YYYY - HH:mm') ? 1 : -1).map(item => (
              <div className="button cor1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '90vw' }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignSelf: 'flex-start', width: '100%' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '100% ' }}>
                    <div className="button-opaque" style={{
                      display: 'flex', flexDirection: 'column', justifyContent: 'center', width: 300, minWidth: 300,
                      marginRight: 10, alignSelf: 'flex-start',
                    }}>
                      <div style={{ fontSize: 16 }}>{item.nome_exame.substring(0, 20) + '...'}</div>
                      <div>{item.data_exame}</div>
                      <div>{item.particular == 1 ? 'PARTICULAR' : 'CONVÊNIO'}</div>
                    </div>
                    <div style={{
                      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', textAlign: 'left',
                      alignSelf: 'center',
                    }}>
                      <div style={{ fontSize: 10, opacity: 0.5 }}>
                        {'ID PROCEDIMENTO: ' + item.id}
                      </div>
                      <div>
                        {'CLIENTE: ' + item.nome_paciente}
                      </div>
                      <div>
                        {'PROFISSIONAL: ' + usuarios.filter(usuario => usuario.id_usuario == item.id_profissional_executante).map(usuario => usuario.nome_usuario)}
                      </div>
                    </div>
                  </div>
                  <div id="faturamento pendente"
                    style={{
                      display: allfaturamento.filter(valor => valor.procedimento_id == item.id).length < 1 ? 'flex' : 'none',
                      flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'flex-start',
                      width: '100%'
                    }}>
                    <div className="button red" style={{ width: 200, alignSelf: 'flex-end' }}>FATURAMENTO PENDENTE!</div>
                  </div>
                </div>
                <div style={{
                  display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'flex-start',
                  width: '100%'
                }}>
                  <div id="elementos do faturamento particular - atendimentos (procedimentos)"
                    className="grid"
                    style={{ width: '100%', display: item.particular == 1 ? 'grid' : 'none' }}>
                    {allfaturamento.filter(valor => valor.procedimento_id == item.id).sort((a, b) => a.parcela < b.parcela ? -1 : 1).map(valor => (
                      <div className={valor.status_pagamento == 'ABERTO' ? 'button yellow' : valor.status_pagamento == 'VENCIDO' ? 'button red' : 'button green'}
                        onClick={() => {
                          setobjatendimento(item);
                          setobjfaturamento(valor);
                          setvieweditfaturamento(1);
                        }}
                        style={{
                          display: 'flex', flexDirection: 'column',
                          justifyContent: 'flex-start',
                          alignContent: 'flex-start',
                          alignItems: 'flex-start',
                          textAlign: 'left',
                        }}>
                        <div style={{ fontSize: 14, textDecoration: 'underline' }}>{valor.forma_pagamento}</div>
                        <div>{'PARCELA: ' + valor.parcela}</div>
                        <div>{'STATUS: ' + valor.status_pagamento}</div>
                        <div>{valor.data_pagamento == null ? 'DATA DO PAGAMENTO: PENDENTE' : 'DATA DO PAGAMENTO: ' + valor.data_pagamento}</div>
                        <div>{'DATA DO VENCIMENTO: ' + valor.data_vencimento}</div>
                        <div style={{ fontSize: 14 }}>{'R$ ' + parseFloat(valor.valor_pagamento).toFixed(2)}</div>
                      </div>
                    ))}
                  </div>
                  <div id="elementos do faturamento convênio - atendimentos (procedimentos)"
                    className="grid"
                    style={{ width: '100%', display: item.convenio == 1 ? 'grid' : 'none' }}>
                    {allfaturamento.filter(valor => valor.procedimento_id == item.id).sort((a, b) => a.parcela < b.parcela ? -1 : 1).map(valor => (
                      <div className={valor.status_pagamento == 'ABERTO' ? 'button yellow' : valor.status_pagamento == 'VENCIDO' ? 'button red' : 'button green'}
                        onClick={() => {
                          setobjatendimento(item);
                          setobjfaturamento(valor);
                        }}
                        style={{
                          display: 'flex', flexDirection: 'column',
                          justifyContent: 'flex-start',
                          alignContent: 'flex-start',
                          alignItems: 'flex-start',
                          textAlign: 'left',
                        }}>
                        <div style={{ fontSize: 14, textDecoration: 'underline' }}>{valor.forma_pagamento}</div>
                        <div>{'OPERADORA: ' + operadoras.filter(op => op.id == valor.id_operadora).map(op => op.nome_operadora)}</div>
                        <div>{'STATUS: ' + valor.status_pagamento}</div>
                        <div>{valor.data_pagamento == null ? 'DATA DO PAGAMENTO: PENDENTE' : 'DATA DO PAGAMENTO: ' + valor.data_pagamento}</div>
                        <div>{'DATA DO VENCIMENTO: ' + valor.data_vencimento}</div>
                        <div style={{ fontSize: 14 }}>{'R$ ' + parseFloat(valor.valor_pagamento).toFixed(2)}</div>
                        <div className="grid2" style={{ marginTop: 10 }}>
                          <div id='confirmar pagamento pela operadora'
                            className="button-green"
                            style={{
                              display: valor.status_pagamento != 'PAGO' ? 'flex' : 'none',
                              height: 100, minHeight: 100,
                            }}
                            onClick={() => updateRegistroProcedimento(valor, 'PAGO', moment().format('DD/MM/YYYY'), parseFloat(valor.valor_pagamento).toFixed(2))}
                          >
                            CONFIRMAR PAGAMENTO PELA OPERADORA
                          </div>
                          <div id='gerarXml - procedimento de convênio'
                            className="button-green"
                            style={{
                              display: 'flex',
                              height: 100, minHeight: 100,
                            }}
                            onClick={() => createxml(dataxmltest)} // SUPER PENDENTE!!!
                          >
                            GERAR XML
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div >
    )
  }

  const [statusatendimento, setstatusatendimento] = useState('');
  const totaisfaturamento = (arrayfaturamento, status) => {
    let total = 0;
    arrayfaturamento.filter(item => item.status_pagamento == status).map(item => {
      total = parseFloat(total) + parseFloat(item.valor_pagamento);
      return null;
    });
    return (
      <div
        className={status == statusatendimento ? "button border-selected" : "button border"}
        style={{
          width: 150, display: 'flex', flexDirection: 'column',
          backgroundColor: status == 'ABERTO' ? "#f5d142" : status == 'VENCIDO' ? "#E59866" : "#52be80"
        }}
        onClick={() => {
          setstatusatendimento(status);
          // capturando atendimentos que têm registros de faturamento com o status do parâmetro.
          let arrayatendimentos = []
          // eslint-disable-next-line
          arrayfaturamento.filter(fat => fat.status_pagamento == status && fat.atendimento_id != null).map(fat => {
            let checkrepeat = arrayatendimentos.filter(atend => atend.id_atendimento == fat.atendimento_id).length;
            if (checkrepeat > 0) {
              console.log('REGISTRO JÁ LANÇADO.')
            } else {
              let atendimento = stateatendimentos_mes.filter(atend => atend.id_atendimento == fat.atendimento_id);
              if (atendimento.length > 0) {
                arrayatendimentos.push(atendimento.pop());
              }
            }
          });
          setatendimentos_mes(arrayatendimentos);
          console.log(arrayatendimentos);
          // capturando atendimentos que têm registros de faturamento com o status do parâmetro.
          let arrayprocedimentos = []
          // eslint-disable-next-line
          arrayfaturamento.filter(fat => fat.status_pagamento == status && fat.procedimento_id != null).map(fat => {
            let procedimento = stateprocedimentos_mes.filter(proc => proc.id == fat.procedimento_id);
            if (procedimento.length > 0) {
              arrayprocedimentos.push(procedimento.pop());
            }
          });
          setprocedimentos_mes(arrayprocedimentos);
          console.log(arrayprocedimentos);
        }}
      >
        <div>{status}</div>
        <div>
          {'R$ ' + total.toFixed(2)}
        </div>
      </div>
    );
  }

  const donutchart = (data, tamanho, fontsize, total) => {
    // tooltip.
    // eslint-disable-next-line
    const CustomTooltip = ({ payload, label }) => {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',
          backgroundColor: 'black', borderRadius: 5, padding: 10, color: 'white',
          fontSize: fontsize, fontWeight: 'bold',
        }}>
          <div>{label}</div>
          {payload.map(item => (
            <div>
              <div>{item.name + ':'}</div>
              <div>{'R$: ' + item.value}</div>
              <div>{Math.ceil(item.value * 100 / total) + '%'}</div>
            </div>
          ))}
        </div>
      )
    }

    // labels.
    const RADIAN = Math.PI / 180;
    let renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value }) => {

      const radius = innerRadius + (outerRadius - innerRadius) * 0.3;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      if (Math.ceil(100 * value / localfaturamento.length) > 0) {
        return (
          <div style={{ backgroundColor: 'black' }} x={x} y={y} fill={'white'} fontWeight={'bold'} fontSize={fontsize} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {Math.ceil(100 * value / localfaturamento.length) + '%'}
          </div>
        );
      } else {
        return null;
      }
    }

    return (
      <div
        className="popin"
        style={{ display: processando == 1 ? 'flex' : 'none', borderRadius: 5, margin: 5 }}>
        <PieChart width={tamanho + 10} height={tamanho + 10} style={{ alignSelf: 'center' }}>
          {localfaturamento.length}
          <Tooltip content={<CustomTooltip payload={[]} />} />
          <Pie
            data={data} dataKey="value" nameKey={"name"} labelLine={false} label={renderLabel} cx={0.5 * tamanho} cy={0.5 * tamanho} outerRadius={0.5 * tamanho} innerRadius={0.2 * tamanho}
            stroke={''} strokeWidth={5}
          >
          </Pie>
        </PieChart>
      </div>
    )
  }

  // DADOS DO GRÁFICO EM LINHA:
  const [consulta_part_mes0, setconsulta_part_mes0] = useState(0);
  const [consulta_part_mes1, setconsulta_part_mes1] = useState(0);
  const [consulta_part_mes2, setconsulta_part_mes2] = useState(0);
  const [consulta_part_mes3, setconsulta_part_mes3] = useState(0);
  const [consulta_part_mes4, setconsulta_part_mes4] = useState(0);
  const [consulta_part_mes5, setconsulta_part_mes5] = useState(0);

  const [consulta_conv_mes0, setconsulta_conv_mes0] = useState(0);
  const [consulta_conv_mes1, setconsulta_conv_mes1] = useState(0);
  const [consulta_conv_mes2, setconsulta_conv_mes2] = useState(0);
  const [consulta_conv_mes3, setconsulta_conv_mes3] = useState(0);
  const [consulta_conv_mes4, setconsulta_conv_mes4] = useState(0);
  const [consulta_conv_mes5, setconsulta_conv_mes5] = useState(0);

  const [exame_part_mes0, setexame_part_mes0] = useState(0);
  const [exame_part_mes1, setexame_part_mes1] = useState(0);
  const [exame_part_mes2, setexame_part_mes2] = useState(0);
  const [exame_part_mes3, setexame_part_mes3] = useState(0);
  const [exame_part_mes4, setexame_part_mes4] = useState(0);
  const [exame_part_mes5, setexame_part_mes5] = useState(0);

  const [exame_conv_mes0, setexame_conv_mes0] = useState(0);
  const [exame_conv_mes1, setexame_conv_mes1] = useState(0);
  const [exame_conv_mes2, setexame_conv_mes2] = useState(0);
  const [exame_conv_mes3, setexame_conv_mes3] = useState(0);
  const [exame_conv_mes4, setexame_conv_mes4] = useState(0);
  const [exame_conv_mes5, setexame_conv_mes5] = useState(0);

  const [allfaturamento, setallfaturamento] = useState([]);
  const getallfaturamento = () => {
    axios.get(html + 'list_faturamento_clinicas/' + cliente.id_cliente).then((response) => {
      let x = [];
      x = response.data.rows;
      setallfaturamento(x);
      localStorage.setItem('storage_allfaturamento', JSON.stringify(x));

      // total de ganhos em consultas particulares.
      let consultas_particulares_mes0 = 0;
      let consultas_particulares_mes1 = 0;
      let consultas_particulares_mes2 = 0;
      let consultas_particulares_mes3 = 0;
      let consultas_particulares_mes4 = 0;
      let consultas_particulares_mes5 = 0;
      // total de ganhos em consultas por convênios.
      let consultas_convenios_mes0 = 0;
      let consultas_convenios_mes1 = 0;
      let consultas_convenios_mes2 = 0;
      let consultas_convenios_mes3 = 0;
      let consultas_convenios_mes4 = 0;
      let consultas_convenios_mes5 = 0;
      // total de ganhos em exames/procedimentos particulares.
      let exames_particulares_mes0 = 0;
      let exames_particulares_mes1 = 0;
      let exames_particulares_mes2 = 0;
      let exames_particulares_mes3 = 0;
      let exames_particulares_mes4 = 0;
      let exames_particulares_mes5 = 0;
      // total de ganhos em exames/procedimentos por convênios.
      let exames_convenios_mes0 = 0;
      let exames_convenios_mes1 = 0;
      let exames_convenios_mes2 = 0;
      let exames_convenios_mes3 = 0;
      let exames_convenios_mes4 = 0;
      let exames_convenios_mes5 = 0;

      // totais recebidos em consultas particulares:
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(5, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_particulares_mes5 = consultas_particulares_mes5 + valor;
        setconsulta_part_mes5(consultas_particulares_mes5);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(4, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_particulares_mes4 = consultas_particulares_mes4 + valor;
        setconsulta_part_mes4(consultas_particulares_mes4);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(3, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_particulares_mes3 = consultas_particulares_mes3 + valor;
        setconsulta_part_mes3(consultas_particulares_mes3);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(2, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_particulares_mes2 = consultas_particulares_mes2 + valor;
        setconsulta_part_mes2(consultas_particulares_mes2);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(1, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_particulares_mes1 = consultas_particulares_mes1 + valor;
        setconsulta_part_mes1(consultas_particulares_mes1);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        console.log(item.valor_pagamento);
        let valor = parseFloat(item.valor_pagamento);
        consultas_particulares_mes0 = consultas_particulares_mes0 + valor;
        setconsulta_part_mes0(consultas_particulares_mes0);
        console.log(consultas_particulares_mes0);
        return null;
      });

      // totais recebidos em consultas por convênio:
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(5, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_convenios_mes5 = consultas_convenios_mes5 + valor;
        setconsulta_conv_mes5(consultas_convenios_mes5);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(4, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_convenios_mes4 = consultas_convenios_mes4 + valor;
        setconsulta_conv_mes4(consultas_convenios_mes4);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(3, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_convenios_mes3 = consultas_convenios_mes3 + valor;
        setconsulta_conv_mes3(consultas_convenios_mes3);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(2, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_convenios_mes2 = consultas_convenios_mes2 + valor;
        setconsulta_conv_mes2(consultas_convenios_mes2);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(1, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_convenios_mes1 = consultas_convenios_mes1 + valor;
        setconsulta_conv_mes1(consultas_convenios_mes1);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(0, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss == 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        consultas_convenios_mes0 = consultas_convenios_mes0 + valor;
        setconsulta_conv_mes0(consultas_convenios_mes0);
        return null;
      });

      // totais recebidos em exames/procedimentos por convênio:
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(5, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_convenios_mes5 = exames_convenios_mes5 + valor;
        setexame_conv_mes5(exames_convenios_mes5);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(4, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_convenios_mes4 = exames_convenios_mes4 + valor;
        setexame_conv_mes4(exames_convenios_mes4);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(3, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_convenios_mes3 = exames_convenios_mes3 + valor;
        setexame_conv_mes3(exames_convenios_mes3);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(2, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_convenios_mes2 = exames_convenios_mes2 + valor;
        setexame_conv_mes2(exames_convenios_mes2);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(1, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_convenios_mes1 = exames_convenios_mes1 + valor;
        setexame_conv_mes1(exames_convenios_mes1);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(0, 'months').format('MM-YYYY') && item.forma_pagamento == 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_convenios_mes0 = exames_convenios_mes0 + valor;
        setexame_conv_mes0(exames_convenios_mes0);
        return null;
      });

      // totais recebidos em exames/procedimentos particulares:
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(5, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_particulares_mes5 = exames_particulares_mes5 + valor;
        setexame_part_mes5(exames_particulares_mes5);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(4, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_particulares_mes4 = exames_particulares_mes4 + valor;
        setexame_part_mes4(exames_particulares_mes4);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(3, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_particulares_mes3 = exames_particulares_mes3 + valor;
        setexame_part_mes3(exames_particulares_mes3);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(2, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_particulares_mes2 = exames_particulares_mes2 + valor;
        setexame_part_mes2(exames_particulares_mes2);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(1, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_particulares_mes1 = exames_particulares_mes1 + valor;
        setexame_part_mes1(exames_particulares_mes1);
        return null;
      });
      x.filter(item => moment(item.data_pagamento, 'DD/MM/YYYY').format('MM-YYYY') == moment().subtract(0, 'months').format('MM-YYYY') && item.forma_pagamento != 'CONVÊNIO' && item.nome_tuss != 'CONSULTA MÉDICA').map(item => {
        let valor = parseFloat(item.valor_pagamento);
        exames_particulares_mes0 = exames_particulares_mes0 + valor;
        setexame_part_mes0(exames_particulares_mes0);
        return null;
      });

    });
  }

  let linedata = [
    {
      id: 'mês 5',
      'MÊS': moment().subtract(5, 'months').format('MM-YYYY'),
      'CONSULTAS PARTICULARES': consulta_part_mes5,
      'CONSULTAS CONVÊNIO': consulta_conv_mes5,
      'EXAMES PARTICULARES': exame_part_mes5,
      'EXAMES CONVÊNIO': exame_conv_mes5,
    },
    {
      id: 'mês 4',
      'MÊS': moment().subtract(4, 'months').format('MM-YYYY'),
      'CONSULTAS PARTICULARES': consulta_part_mes4,
      'CONSULTAS CONVÊNIO': consulta_conv_mes4,
      'EXAMES PARTICULARES': exame_part_mes4,
      'EXAMES CONVÊNIO': exame_conv_mes4,
    },
    {
      id: 'mês 3',
      'MÊS': moment().subtract(3, 'months').format('MM-YYYY'),
      'CONSULTAS PARTICULARES': consulta_part_mes3,
      'CONSULTAS CONVÊNIO': consulta_conv_mes3,
      'EXAMES PARTICULARES': exame_part_mes3,
      'EXAMES CONVÊNIO': exame_conv_mes3,
    },
    {
      id: 'mês 2',
      'MÊS': moment().subtract(2, 'months').format('MM-YYYY'),
      'CONSULTAS PARTICULARES': consulta_part_mes2,
      'CONSULTAS CONVÊNIO': consulta_conv_mes2,
      'EXAMES PARTICULARES': exame_part_mes2,
      'EXAMES CONVÊNIO': exame_conv_mes2,
    },
    {
      id: 'mês 1',
      'MÊS': moment().subtract(1, 'months').format('MM-YYYY'),
      'CONSULTAS PARTICULARES': consulta_part_mes1,
      'CONSULTAS CONVÊNIO': consulta_conv_mes1,
      'EXAMES PARTICULARES': exame_part_mes1,
      'EXAMES CONVÊNIO': exame_conv_mes1,
    },
    {
      id: 'mês 0',
      'MÊS': moment().format('MM-YYYY'),
      'CONSULTAS PARTICULARES': consulta_part_mes0,
      'CONSULTAS CONVÊNIO': consulta_conv_mes0,
      'EXAMES PARTICULARES': exame_part_mes0,
      'EXAMES CONVÊNIO': exame_conv_mes0,
    },
  ]


  const lineChart = (data) => {

    const CustomTooltip = ({ payload, label }) => {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',
          backgroundColor: 'black', borderRadius: 5, padding: 10, color: 'white',
          fontSize: '12px', fontWeight: 'bold',
        }}>
          <div>{label}</div>
          {payload.map(item => (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
              <div style={{ marginRight: 5 }}>{item.name + ':'}</div>
              <div>{'R$ ' + item.value}</div>
            </div>
          ))}
        </div>
      )
    }

    return (
      <div>
        <div
          className="popin"
          style={{
            display: processando == 1 ? 'flex' : 'none',
            borderRadius: 5, margin: 5, alignSelf: 'center',
            width: '50vw',
          }}>
          <ComposedChart width={700} height={200} data={data} style={{ alignSelf: 'center' }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="MÊS" style={{ fontSize: '12px' }} />
            <YAxis style={{ fontSize: '12px' }} />
            <Tooltip content={<CustomTooltip payload={[]} />} />
            <Legend wrapperStyle={{ fontSize: "12px" }} />
            <Line type="monotone" dataKey="CONSULTAS PARTICULARES" stroke="#5dade2" label={{ display: 'none' }} />
            <Area type="monotone" dataKey="CONSULTAS CONVÊNIO" stroke="#aed6f1" fill="#aed6f1" fillOpacity={0.3} label={{ display: 'none', fontSize: 12 }} />
            <Line type="monotone" dataKey="EXAMES PARTICULARES" stroke="#48c9b0" label={{ display: 'none' }} />
            <Area type="monotone" dataKey="EXAMES CONVÊNIO" stroke="#a3e4d7" fill="#a3e4d7" fillOpacity={0.3} label={{ display: 'none', fontSize: 12 }} />
          </ComposedChart>
        </div>
        <div
          style={{
            display: processando == 0 ? 'flex' : 'none',
            borderRadius: 5, margin: 5, alignSelf: 'center',
            width: '50vw',
            justifyContent: 'center',
            opacity: 0.2,
          }}>
          <div style={{ display: 'flex', alignSelf: 'center' }} className="text1">PROCESSANDO...</div>
        </div>
      </div>
    )
  }

  function TotaisFaturamento() {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          {donutchart(donutfaturamentodata(), 200, 16, buildtotalvalorfaturamento(localfaturamento))}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 5 }}>
          {totaisfaturamento(localfaturamento, 'ABERTO')}
          {totaisfaturamento(localfaturamento, 'VENCIDO')}
          {totaisfaturamento(localfaturamento, 'PAGO')}
        </div>
        {lineChart(linedata)}
      </div>
    )
  }

  const [vieweditfaturamento, setvieweditfaturamento] = useState(0);
  function EditFaturamento() {
    const [statusfatura, setstatusfatura] = useState(null);
    return (
      <div className="fundo"
        style={{ display: vieweditfaturamento == 1 ? 'flex' : 'none', flexDirection: 'column', justifyContent: 'center' }}
        onClick={() => setvieweditfaturamento(0)}
      >
        <div
          className="janela scroll cor2"
          onClick={(e) => e.stopPropagation()}>
          <div className="text1" style={{ fontSize: 20 }}>RESUMO DA FATURA</div>
          <div className="text1">VALOR DO PAGAMENTO</div>
          <input
            className="input"
            autoComplete="off"
            placeholder="VALOR DO PAGAMENTO"
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "VALOR DO PAGAMENTO (R$)")}
            onKeyUp={() => masknumber(1000, "inputValorDoPagamento", 200)}
            type="text"
            id="inputValorDoPagamento"
            defaultValue={objfaturamento != null ? parseFloat(objfaturamento.valor_pagamento).toFixed(2) : ''}
            maxLength={200}
            style={{ margin: 5, width: window.innerWidth < 426 ? 200 : 200 }}
          >
          </input>
          <div
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            <div className={statusfatura == 'PAGO' ? "button-selected" : "button-green"}
              style={{ display: 'flex', minWidth: 150, width: 150, maxWidth: 150 }}
              onClick={() => setstatusfatura('PAGO')}
            >
              {'PAGO'}
            </div>
            <div className={statusfatura == 'ABERTO' ? "button-selected" : "button-yellow"}
              style={{ display: 'flex', minWidth: 150, width: 150, maxWidth: 150 }}
              onClick={() => setstatusfatura('ABERTO')}
            >
              {'ABERTO'}
            </div>
            <div className={statusfatura == 'VENCIDO' ? "button-selected" : "button-red"}
              style={{ display: 'flex', minWidth: 150, width: 150, maxWidth: 150 }}
              onClick={() => setstatusfatura('VENCIDO')}
            >
              {'VENCIDO'}
            </div>
          </div>
          <div
            className="button" style={{ paddingLeft: 15, paddingRight: 15 }}
            onClick={() => {
              if (document.getElementById("inputValorDoPagamento").value != '') {
                if (statusfatura == 'PAGO') {
                  updateRegistroProcedimento(objfaturamento, statusfatura, moment().format('DD/MM/YYYY'), document.getElementById('inputValorDoPagamento').value);
                } else {
                  updateRegistroProcedimento(objfaturamento, statusfatura, null, document.getElementById('inputValorDoPagamento').value);
                }
              } else {
                toast(
                  settoast,
                  "PREENCHA O VALOR",
                  "#EC7063",
                  1000)
              }
            }}
          >
            ATUALIZAR INFORMAÇÕES
          </div>
          <div className="button green"
            onClick={
              () => {
                setreciboform(1);
                localStorage.setItem('pagador', atendimentos_mes.filter(atend => atend.id_atendimento == objfaturamento.atendimento_id).map(atend => atend.nome_paciente));
                localStorage.setItem('procedimento', 'CONSULTA MÉDICA');
              }
            }
            style={{ paddingLeft: 15, paddingRight: 15 }}>
            GERAR RECIBO
          </div>
        </div>
      </div >
    )
  }

  const updateRegistroProcedimento = (item, status, data_pgto, valor) => {
    let obj = {
      cliente_id: cliente.id_cliente,
      cliente_nome: cliente.razao_social,
      atendimento_id: item.atendimento_id,
      procedimento_id: item.procedimento_id,
      data_pagamento: data_pgto,
      data_vencimento: item.data_vencimento,
      parcela: item.parcela,
      forma_pagamento: item.forma_pagamento,
      status_pagamento: status,
      valor_pagamento: valor,
      id_operadora: item.id_operadora,
      codigo_operadora: item.codigo_operadora,
      codigo_tuss: item.codigo_tuss,
      nome_tuss: item.nome_tuss,
      data_registro: item.data_registro,
    }
    axios.post(html + 'update_faturamento_clinicas/' + item.id, obj).then(() => {
      setprocessando(0);
      filtraregistrosconsultas(selecteddate);
      filtraregistrosprocedimentos(selecteddate);
      loadfaturamentosmes(selecteddate);
      getallfaturamento();
      console.log('REGISTRO DE FATURAMENTO ATUALIZADO COM SUCESSO');
      setvieweditfaturamento(0);
    })
  }

  // ## CRIAÇÃO DE RECIBOS EM PDFMAKE ## //
  // impressão de recibo de pagamento (consulta ou procedimento particular).
  const printRecibo = () => {
    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      pageMargins: [40, 200, 40, 120],
      header: {
        stack: [
          {
            columns: [
              {
                image: cliente.logo,
                width: 75,
                alignment: 'center',
              },
              {
                stack: [
                  { text: cliente.razao_social, alignment: 'left', fontSize: 10, width: 300 },
                  { text: 'ENDEREÇO: ' + cliente.endereco, alignment: 'left', fontSize: 6, width: 300 },
                  { text: 'TELEFONE: ' + cliente.telefone, alignment: 'left', fontSize: 6, width: 300 },
                  { text: 'EMAIL: ' + cliente.email, alignment: 'left', fontSize: 6, width: 300 },
                ],
                width: '*'
              },
              { qr: cliente.qrcode, width: '40%', fit: 75, alignment: 'right', margin: [0, 0, 10, 0] },
            ],
            columnGap: 10,
          },
          {
            "canvas": [{
              "lineColor": "gray",
              "type": "line",
              "x1": 0,
              "y1": 0,
              "x2": 524,
              "y2": 0,
              "lineWidth": 1
            }], margin: [0, 10, 0, 0], alignment: 'center',
          },

        ],
        margin: [40, 40, 40, 40],
      },
      footer: function (currentPage, pageCount) {
        return {
          stack: [
            {
              "canvas": [{
                "lineColor": "gray",
                "type": "line",
                "x1": 0,
                "y1": 0,
                "x2": 524,
                "y2": 0,
                "lineWidth": 1
              }], margin: [0, 10, 0, 0], alignment: 'center',
            },
            {
              columns: [
                {
                  stack: [
                    { text: '________________________________', alignment: 'center', width: 400 },
                    { text: 'DEPARTAMENTO FINANCEIRO', width: '*', alignment: 'center', fontSize: 8 },
                  ], with: '30%',
                },
                { text: 'PÁGINA ' + currentPage.toString() + ' DE ' + pageCount, fontSize: 8 },
                { text: '', width: '*' },
              ],
              margin: [40, 40, 40, 40], alignment: 'center',
            },
          ],
        }
      },
      content: [
        { text: 'RECIBO DE PAGAMENTO', alignment: 'center', fontSize: 14, bold: true, margin: 10 },
        { text: localStorage.getItem('texto_recibo'), fontSize: 10, bold: false },
        { text: '---x---', fontSize: 10, bold: true, color: '#ffffff' },
        { text: 'INFORMAÇÕES DO RECEBEDOR:', fontSize: 10, bold: true },
        { text: 'CNPJ: ' + cliente.cnpj, fontSize: 10, bold: false },
        { text: 'RAZÃO SOCIAL: ' + cliente.razao_social, fontSize: 10, bold: false },
        { text: 'ENDEREÇO: ' + cliente.endereco, fontSize: 10, bold: false },
      ],
    }
    // utilizando a lib pdfmake para gerar o pdf e converter em base64.
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.open();
  }
  const [reciboform, setreciboform] = useState(0);
  function ReciboNomePagador() {
    return (
      <div
        className="fundo"
        style={{ display: reciboform == 1 ? "flex" : "none" }}
        onClick={() => { setreciboform(0) }}
      >
        <div className="janela scroll cor2" onClick={(e) => e.stopPropagation()}>
          <div className='text1'>NOME DO PAGADOR</div>
          <input id="inputNomePagador"
            autoComplete="off"
            placeholder="NOME DO PAGADOR..."
            className="input"
            type="text"
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "NOME DO PAGADOR...")}
            defaultValue={localStorage.getItem('pagador')}
            style={{
              flexDirection: "center",
              justifyContent: "center",
              alignSelf: "center",
              textAlign: "center",
              width: 400,
              padding: 15,
              height: 20,
              minHeight: 20,
              maxHeight: 20,
            }}
          ></input>
          <div className='text1'>DOCUMENTO DO PAGADOR</div>
          <input id="inputDocumentoPagador"
            autoComplete="off"
            placeholder="DOCUMENTO DO PAGADOR..."
            className="input"
            type="text"
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "DOCUMENTO DO PAGADOR...")}
            style={{
              flexDirection: "center",
              justifyContent: "center",
              alignSelf: "center",
              textAlign: "center",
              width: 400,
              padding: 15,
              height: 20,
              minHeight: 20,
              maxHeight: 20,
            }}
          ></input>
          <div className='button green'
            style={{ width: 200 }}
            onClick={() => {
              let total_parcelas = localfaturamento.filter(fat => fat.atendimento_id == objfaturamento.atendimento_id).length;
              if (total_parcelas < 2) {
                let texto = 'RECEBEMOS DE ' + document.getElementById('inputNomePagador').value.toUpperCase() + ', ' + document.getElementById('inputDocumentoPagador').value + ', A IMPORTÂNCIA DE R$ ' + objfaturamento.valor_pagamento + ', REFERENTE À REALIZAÇÃO DO EXAME/PROCEDIMENTO ' + localStorage.getItem('procedimento');
                localStorage.setItem('texto_recibo', texto);
              } else {
                let texto = 'RECEBEMOS DE ' + document.getElementById('inputNomePagador').value.toUpperCase() + ', ' + document.getElementById('inputDocumentoPagador').value + ', A IMPORTÂNCIA DE R$ ' + objfaturamento.valor_pagamento + ', PARCELA ' + objfaturamento.parcela + ' DE ' + total_parcelas + ', REFERENTE À REALIZAÇÃO DO EXAME/PROCEDIMENTO:' + localStorage.getItem('procedimento');
                localStorage.setItem('texto_recibo', texto);
              }
              printRecibo();
              setreciboform(0);
            }}
          >
            IMPRIMIR RECIBO
          </div>
        </div>
      </div>
    )
  }

  // ## IMPRESSÃO DE RELATÓRIOS DE FATURAMENTO ## //
  const printRelatorioFaturamento = () => {
    let tabledataconsultas = [];
    let tabledataprocedimentos = [];

    let totais = {
      columns: [
        { text: 'TOTAL EM ABERTO: R$ ' + parseFloat(dadosdonutaberto), alignment: 'center', bold: true, margin: [0, 10, 0, 0] },
        { text: 'TOTAL RECEBIDO: R$ ' + parseFloat(dadosdonutpago), alignment: 'center', bold: true, margin: [0, 10, 0, 0] },
        { text: 'TOTAL VENCIDO: R$ ' + parseFloat(dadosdonutvencido), alignment: 'center', bold: true, margin: [0, 10, 0, 0] },
      ]
    }

    // eslint-disable-next-line
    atendimentos_mes.sort((a, b) => moment(a.data_inicio) > moment(b.data_inicio) ? 1 : -1).filter(item => item.nome_paciente != 'HORÁRIO BLOQUEADO!').map(item => {
      let tablefaturamentos = [];
      let formapagamento = null;
      // eslint-disable-next-line
      localfaturamento.filter(valor => valor.atendimento_id == item.id_atendimento).sort((a, b) => a.parcela < b.parcela ? -1 : 1).map(faturamento => {
        formapagamento = faturamento.forma_pagamento;
        if (formapagamento != 'CONVÊNIO') {
          tablefaturamentos.push(
            [
              { text: faturamento.parcela }, { text: faturamento.status_pagamento }, { text: faturamento.data_pagamento }, { text: faturamento.valor_pagamento }
            ]
          );
        } else {
          tablefaturamentos.push(
            // 'OPERADORA', 'CÓDIGO_TUSS', STATUS, 'DATA PGTO', 'VALOR'
            [
              { text: operadoras.filter(op => op.id == faturamento.id_operadora).map(op => op.nome_operadora) }, { text: faturamento.codigo_tuss }, { text: faturamento.status_pagamento }, { text: faturamento.data_pagamento }, { text: faturamento.valor_pagamento }
            ]
          );
        }
      })
      if (localfaturamento.filter(fat => fat.atendimento_id == item.id_atendimento).length > 0) {
        if (formapagamento != 'CONVÊNIO') {
          tabledataconsultas.push(
            [
              { text: moment(item.data_inicio).format('DD/MM/YYYY') }, { text: 'CONSULTA' }, { text: item.nome_paciente },
              { text: usuarios.filter(usuario => usuario.id_usuario == item.id_profissional).map(usuario => usuario.nome_usuario) },
              { text: formapagamento },
              {
                style: 'table',
                table: {
                  // headerRows: 1,
                  widths: [75, 75, 75, 75],
                  body: [
                    ['PARCELA', 'STATUS', 'DATA PGTO', 'VALOR'],
                    ...tablefaturamentos,
                  ]
                }
              },
            ],
          );
        } else {
          tabledataconsultas.push(
            [
              { text: moment(item.data_inicio).format('DD/MM/YYYY') }, { text: 'CONSULTA' }, { text: item.nome_paciente },
              { text: usuarios.filter(usuario => usuario.id_usuario == item.id_profissional).map(usuario => usuario.nome_usuario) },
              { text: formapagamento },
              {
                style: 'table',
                table: {
                  // headerRows: 1,
                  widths: [75, 75, 75, 75, 75],
                  body: [
                    ['OPERADORA', 'CÓDIGO_TUSS', 'STATUS', 'DATA PGTO', 'VALOR'],
                    ...tablefaturamentos,
                  ]
                }
              },
            ],
          );
        }
      }

    });
    // eslint-disable-next-line
    procedimentos_mes.sort((a, b) => moment(a.data_exame, 'DD/MM/YYYY - HH:mm') > moment(b.data_exame, 'DD/MM/YYYY - HH:mm') ? 1 : -1).map(item => {
      let tablefaturamentos = [];
      let formapagamento = null;
      // eslint-disable-next-line
      localfaturamento.filter(valor => valor.procedimento_id == item.id).sort((a, b) => a.parcela < b.parcela ? -1 : 1).map(faturamento => {
        formapagamento = faturamento.forma_pagamento;
        if (formapagamento != 'CONVÊNIO') {
          tablefaturamentos.push(
            [
              { text: faturamento.parcela }, { text: faturamento.status_pagamento }, { text: faturamento.data_pagamento }, { text: faturamento.valor_pagamento }
            ]
          );
        } else {
          tablefaturamentos.push(
            [
              { text: operadoras.filter(op => op.id == faturamento.id_operadora).map(op => op.nome_operadora) }, { text: faturamento.codigo_tuss }, { text: faturamento.status_pagamento }, { text: faturamento.data_pagamento }, { text: faturamento.valor_pagamento }
            ]
          );
        }
      })
      if (localfaturamento.filter(fat => fat.procedimento_id == item.id).length > 0) {
        if (formapagamento != 'CONVÊNIO') {
          tabledataprocedimentos.push(
            [
              { text: item.data_exame }, { text: item.nome_exame }, { text: item.nome_paciente },
              { text: usuarios.filter(usuario => usuario.id_usuario == item.id_profissional_executante).map(usuario => usuario.nome_usuario) },
              { text: formapagamento },
              {
                style: 'table',
                table: {
                  // headerRows: 1,
                  widths: [75, 75, 75, 75],
                  body: [
                    ['PARCELA', 'STATUS', 'DATA PGTO', 'VALOR (R$)'],
                    ...tablefaturamentos,
                  ]
                }
              },
            ],
          );
        } else {
          tabledataprocedimentos.push(
            [
              { text: moment(item.data_inicio).format('DD/MM/YYYY') }, { text: item.nome_exame }, { text: item.nome_paciente },
              { text: usuarios.filter(usuario => usuario.id_usuario == item.id_profissional).map(usuario => usuario.nome_usuario) },
              { text: formapagamento },
              {
                style: 'table',
                table: {
                  // headerRows: 1,
                  widths: [75, 75, 75, 75, 75],
                  body: [
                    ['OPERADORA', 'CÓDIGO_TUSS', 'STATUS', 'DATA PGTO', 'VALOR (R$)'],
                    ...tablefaturamentos,
                  ]
                }
              },
            ],
          );
        }
      }
    });

    let docDefinition = {};
    if (tabledataconsultas.length > 0 && tabledataprocedimentos.length > 0) {
      docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 200, 40, 120],
        header: {
          stack: [
            {
              columns: [
                {
                  image: cliente.logo,
                  width: 75,
                  alignment: 'center',
                },
                {
                  stack: [
                    { text: cliente.razao_social, alignment: 'left', fontSize: 10, width: 300 },
                    { text: 'ENDEREÇO: ' + cliente.endereco, alignment: 'left', fontSize: 6, width: 300 },
                    { text: 'TELEFONE: ' + cliente.telefone, alignment: 'left', fontSize: 6, width: 300 },
                    { text: 'EMAIL: ' + cliente.email, alignment: 'left', fontSize: 6, width: 300 },
                  ],
                  width: '*'
                },
                { qr: cliente.qrcode, width: '40%', fit: 75, alignment: 'right', margin: [0, 0, 10, 0] },
              ],
              columnGap: 10,
            },
            {
              "canvas": [{
                "lineColor": "gray",
                "type": "line",
                "x1": 0,
                "y1": 0,
                "x2": 524,
                "y2": 0,
                "lineWidth": 1
              }], margin: [0, 10, 0, 0], alignment: 'center',
            },

          ],
          margin: [40, 40, 40, 40],
        },
        footer: function (currentPage, pageCount) {
          return {
            stack: [
              {
                "canvas": [{
                  "lineColor": "gray",
                  "type": "line",
                  "x1": 0,
                  "y1": 0,
                  "x2": 524,
                  "y2": 0,
                  "lineWidth": 1
                }], margin: [0, 10, 0, 0], alignment: 'center',
              },
              {
                columns: [
                  {
                    stack: [
                      { text: '________________________________', alignment: 'center', width: 400 },
                      { text: 'DEPARTAMENTO FINANCEIRO', width: '*', alignment: 'center', fontSize: 8 },
                    ], with: '30%',
                  },
                  { text: 'PÁGINA ' + currentPage.toString() + ' DE ' + pageCount, fontSize: 8 },
                  { text: '', width: '*' },
                ],
                margin: [40, 40, 40, 40], alignment: 'center',
              },
            ],
          }
        },
        styles: {
          title: {
            fontsize: 20,
            bold: true,
            alignment: 'center',
            margin: [2.5, 10, 2.5, 5]
          },
          tableheaders: {
            fontSize: 10,
            bold: true,
            fill: 'blue'
          },
          tablecells: {
            fontSize: 10,
            bold: false,
          },
        },
        content: [
          { text: localStorage.getItem('objeto_usuario') != 'todos' ? 'FATURAMENTO - PROFISSIONAL: ' + JSON.parse(localStorage.getItem('objeto_usuario')).nome_usuario + ' - ' + JSON.parse(localStorage.getItem('objeto_usuario')).conselho + ' ' + JSON.parse(localStorage.getItem('objeto_usuario')).n_conselho : '', style: 'title' },
          { text: 'FATURAMENTO DE CONSULTAS', style: 'title' },
          {
            style: 'tablecells',
            table: {
              headerRows: 1,
              dontBreakRows: true,
              body: [
                [{ text: 'DATA', style: 'tableheaders' }, { text: 'PROCEDIMENTO', style: 'tableheaders' }, { text: 'CLIENTE', style: 'tableheaders' }, { text: 'PROFISSIONAL EXECUTANTE', style: 'tableheaders' }, { text: 'FORMA DE PAGAMENTO', style: 'tableheaders' }, { text: 'PAGAMENTOS', style: 'tableheaders' }],
                ...tabledataconsultas
              ],
            },

          },
          { text: 'FATURAMENTO DE PROCEDIMENTOS E EXAMES', style: 'title' },
          {
            style: 'tablecells',
            table: {
              headerRows: 1,
              dontBreakRows: true,
              body: [
                [{ text: 'DATA', style: 'tableheaders' }, { text: 'PROCEDIMENTO', style: 'tableheaders' }, { text: 'CLIENTE', style: 'tableheaders' }, { text: 'PROFISSIONAL EXECUTANTE', style: 'tableheaders' }, { text: 'FORMA DE PAGAMENTO', style: 'tableheaders' }, { text: 'PAGAMENTOS', style: 'tableheaders' }],
                ...tabledataprocedimentos
              ],
            },
          },
          [totais],
        ],
      }
    } else if (tabledataconsultas.length > 0 && tabledataprocedimentos.length == 0) {
      docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 200, 40, 120],
        header: {
          stack: [
            {
              columns: [
                {
                  image: cliente.logo,
                  width: 75,
                  alignment: 'center',
                },
                {
                  stack: [
                    { text: cliente.razao_social, alignment: 'left', fontSize: 10, width: 300 },
                    { text: 'ENDEREÇO: ' + cliente.endereco, alignment: 'left', fontSize: 6, width: 300 },
                    { text: 'TELEFONE: ' + cliente.telefone, alignment: 'left', fontSize: 6, width: 300 },
                    { text: 'EMAIL: ' + cliente.email, alignment: 'left', fontSize: 6, width: 300 },
                  ],
                  width: '*'
                },
                { qr: cliente.qrcode, width: '40%', fit: 75, alignment: 'right', margin: [0, 0, 10, 0] },
              ],
              columnGap: 10,
            },
            {
              "canvas": [{
                "lineColor": "gray",
                "type": "line",
                "x1": 0,
                "y1": 0,
                "x2": 524,
                "y2": 0,
                "lineWidth": 1
              }], margin: [0, 10, 0, 0], alignment: 'center',
            },

          ],
          margin: [40, 40, 40, 40],
        },
        footer: function (currentPage, pageCount) {
          return {
            stack: [
              {
                "canvas": [{
                  "lineColor": "gray",
                  "type": "line",
                  "x1": 0,
                  "y1": 0,
                  "x2": 524,
                  "y2": 0,
                  "lineWidth": 1
                }], margin: [0, 10, 0, 0], alignment: 'center',
              },
              {
                columns: [
                  {
                    stack: [
                      { text: '________________________________', alignment: 'center', width: 400 },
                      { text: 'DEPARTAMENTO FINANCEIRO', width: '*', alignment: 'center', fontSize: 8 },
                    ], with: '30%',
                  },
                  { text: 'PÁGINA ' + currentPage.toString() + ' DE ' + pageCount, fontSize: 8 },
                  { text: '', width: '*' },
                ],
                margin: [40, 40, 40, 40], alignment: 'center',
              },
            ],
          }
        },
        styles: {
          title: {
            fontsize: 20,
            bold: true,
            alignment: 'center',
            margin: [2.5, 10, 2.5, 5]
          },
          tableheaders: {
            fontSize: 10,
            bold: true,
            fill: 'blue'
          },
          tablecells: {
            fontSize: 10,
            bold: false,
          },
        },
        content: [
          { text: 'FATURAMENTO DE CONSULTAS', style: 'title' },
          {
            style: 'tablecells',
            table: {
              headerRows: 1,
              dontBreakRows: true,
              body: [
                [{ text: 'DATA', style: 'tableheaders' }, { text: 'PROCEDIMENTO', style: 'tableheaders' }, { text: 'CLIENTE', style: 'tableheaders' }, { text: 'PROFISSIONAL EXECUTANTE', style: 'tableheaders' }, { text: 'FORMA DE PAGAMENTO', style: 'tableheaders' }, { text: 'PAGAMENTOS', style: 'tableheaders' }],
                ...tabledataconsultas
              ],
            },
          },
          [totais],
        ],
      }
    } else if (tabledataconsultas.length == 0 && tabledataprocedimentos.length > 0) {
      docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 200, 40, 120],
        header: {
          stack: [
            {
              columns: [
                {
                  image: cliente.logo,
                  width: 75,
                  alignment: 'center',
                },
                {
                  stack: [
                    { text: cliente.razao_social, alignment: 'left', fontSize: 10, width: 300 },
                    { text: 'ENDEREÇO: ' + cliente.endereco, alignment: 'left', fontSize: 6, width: 300 },
                    { text: 'TELEFONE: ' + cliente.telefone, alignment: 'left', fontSize: 6, width: 300 },
                    { text: 'EMAIL: ' + cliente.email, alignment: 'left', fontSize: 6, width: 300 },
                  ],
                  width: '*'
                },
                { qr: cliente.qrcode, width: '40%', fit: 75, alignment: 'right', margin: [0, 0, 10, 0] },
              ],
              columnGap: 10,
            },
            {
              "canvas": [{
                "lineColor": "gray",
                "type": "line",
                "x1": 0,
                "y1": 0,
                "x2": 524,
                "y2": 0,
                "lineWidth": 1
              }], margin: [0, 10, 0, 0], alignment: 'center',
            },

          ],
          margin: [40, 40, 40, 40],
        },
        footer: function (currentPage, pageCount) {
          return {
            stack: [
              {
                "canvas": [{
                  "lineColor": "gray",
                  "type": "line",
                  "x1": 0,
                  "y1": 0,
                  "x2": 524,
                  "y2": 0,
                  "lineWidth": 1
                }], margin: [0, 10, 0, 0], alignment: 'center',
              },
              {
                columns: [
                  {
                    stack: [
                      { text: '________________________________', alignment: 'center', width: 400 },
                      { text: 'DEPARTAMENTO FINANCEIRO', width: '*', alignment: 'center', fontSize: 8 },
                    ], with: '30%',
                  },
                  { text: 'PÁGINA ' + currentPage.toString() + ' DE ' + pageCount, fontSize: 8 },
                  { text: '', width: '*' },
                ],
                margin: [40, 40, 40, 40], alignment: 'center',
              },
            ],
          }
        },
        styles: {
          title: {
            fontsize: 20,
            bold: true,
            alignment: 'center',
            margin: [2.5, 10, 2.5, 5]
          },
          tableheaders: {
            fontSize: 10,
            bold: true,
            fill: 'blue'
          },
          tablecells: {
            fontSize: 10,
            bold: false,
          },
        },
        content: [
          { text: 'FATURAMENTO DE PROCEDIMENTOS E EXAMES', style: 'title' },
          {
            style: 'tablecells',
            table: {
              headerRows: 1,
              dontBreakRows: true,
              body: [
                [{ text: 'DATA', style: 'tableheaders' }, { text: 'PROCEDIMENTO', style: 'tableheaders' }, { text: 'CLIENTE', style: 'tableheaders' }, { text: 'PROFISSIONAL EXECUTANTE', style: 'tableheaders' }, { text: 'FORMA DE PAGAMENTO', style: 'tableheaders' }, { text: 'PAGAMENTOS', style: 'tableheaders' }],
                ...tabledataprocedimentos
              ],
            },
          },
          [totais],
        ],
      }
    } else {
      docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 200, 40, 120],
        header: {
          stack: [
            {
              columns: [
                {
                  image: cliente.logo,
                  width: 75,
                  alignment: 'center',
                },
                {
                  stack: [
                    { text: cliente.razao_social, alignment: 'left', fontSize: 10, width: 300 },
                    { text: 'ENDEREÇO: ' + cliente.endereco, alignment: 'left', fontSize: 6, width: 300 },
                    { text: 'TELEFONE: ' + cliente.telefone, alignment: 'left', fontSize: 6, width: 300 },
                    { text: 'EMAIL: ' + cliente.email, alignment: 'left', fontSize: 6, width: 300 },
                  ],
                  width: '*'
                },
                { qr: cliente.qrcode, width: '40%', fit: 75, alignment: 'right', margin: [0, 0, 10, 0] },
              ],
              columnGap: 10,
            },
            {
              "canvas": [{
                "lineColor": "gray",
                "type": "line",
                "x1": 0,
                "y1": 0,
                "x2": 524,
                "y2": 0,
                "lineWidth": 1
              }], margin: [0, 10, 0, 0], alignment: 'center',
            },

          ],
          margin: [40, 40, 40, 40],
        },
        footer: function (currentPage, pageCount) {
          return {
            stack: [
              {
                "canvas": [{
                  "lineColor": "gray",
                  "type": "line",
                  "x1": 0,
                  "y1": 0,
                  "x2": 524,
                  "y2": 0,
                  "lineWidth": 1
                }], margin: [0, 10, 0, 0], alignment: 'center',
              },
              {
                columns: [
                  {
                    stack: [
                      { text: '________________________________', alignment: 'center', width: 400 },
                      { text: 'DEPARTAMENTO FINANCEIRO', width: '*', alignment: 'center', fontSize: 8 },
                    ], with: '30%',
                  },
                  { text: 'PÁGINA ' + currentPage.toString() + ' DE ' + pageCount, fontSize: 8 },
                  { text: '', width: '*' },
                ],
                margin: [40, 40, 40, 40], alignment: 'center',
              },
            ],
          }
        },
        styles: {
          title: {
            fontsize: 20,
            bold: true,
            alignment: 'center',
            margin: [2.5, 10, 2.5, 5]
          },
          tableheaders: {
            fontSize: 10,
            bold: true,
            fill: 'blue'
          },
          tablecells: {
            fontSize: 10,
            bold: false,
          },
        },
        content: [
          { text: 'SEM DADOS PARA APRESENTAÇÃO COM OS FILTROS APLICADOS.', style: 'title' },
        ],
      }
    }
    // utilizando a lib pdfmake para gerar o pdf e converter em base64.
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.open();
  }

  // ## CRIAÇÃO DOS ARQUIVOS XML ## //
  const dataxmltest = {
    Planet: [
      {
        "position": "1",
        "name": "<Mercury>",
        "distance": "58",
      },
    ]
  }

  const createxml = (data) => {
    const xml = parser.jsXml.toXmlString(data);
    console.log(xml);
    var filename = "file.xml";
    var pom = document.createElement('a');
    var bb = new Blob([xml], { type: 'text/plain' });
    pom.setAttribute('href', window.URL.createObjectURL(bb));
    pom.setAttribute('download', filename);
    pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
    pom.draggable = true;
    pom.classList.add('dragout');
    pom.click();
  }

  return (
    <div id="tela de faturamento"
      className='main'
      style={{
        display: pagina == 'FATURAMENTO' ? 'flex' : 'none',
        backgroundColor: menufaturamento == 'REGISTROS DE FATURAMENTO' ? 'white' : '',
      }}
    >
      <div className='chassi scroll'
        style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',
          width: 'calc(100vw - 20px)',
        }}>
        <div style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'center',
          alignItems: 'center',
        }}>
          <MenuFaturamento></MenuFaturamento>
          <div style={{
            display: menufaturamento == 'CADASTRO DE OPERADORAS E PROCEDIMENTOS' ? 'flex' : 'none',
            flexDirection: 'column', justifyContent: 'center'
          }}>
            <ViewOperadoras></ViewOperadoras>
          </div>
          <div style={{
            display: menufaturamento == 'REGISTROS DE FATURAMENTO' ? 'flex' : 'none',
            flexDirection: 'column', justifyContent: 'center'
          }}>
            <ListaDeFaturamentos></ListaDeFaturamentos>
            <EditFaturamento></EditFaturamento>
            <ReciboNomePagador></ReciboNomePagador>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Faturamento;